var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2228.24 1470.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-10,.cls-11,.cls-29,.cls-3,.cls-44,.cls-45,.cls-50,.cls-6{fill:#fff;}.cls-4{fill:#bdd0fb;}.cls-5{fill:#dce5fe;}.cls-6{opacity:0.5;}.cls-7{fill:#7d97f4;}.cls-8{fill:#2b69b3;}.cls-9{fill:#18174a;}.cls-10{opacity:0.39;}.cls-11{opacity:0.66;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{opacity:0.2;}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-20);}.cls-32{fill:url(#linear-gradient-21);}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}.cls-44{opacity:0.72;}.cls-45{opacity:0.78;}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48,.cls-50{opacity:0.6;}.cls-49{fill:url(#linear-gradient-35);}.cls-51{fill:url(#linear-gradient-36);}.cls-52{fill:url(#linear-gradient-37);}.cls-53{fill:url(#linear-gradient-38);}.cls-54{fill:url(#linear-gradient-39);}.cls-55{fill:url(#linear-gradient-40);}.cls-56{opacity:0.24;}.cls-57{fill:url(#linear-gradient-41);}.cls-58{fill:url(#linear-gradient-42);}.cls-59{fill:url(#linear-gradient-43);}.cls-60{fill:url(#linear-gradient-44);}.cls-61{fill:url(#linear-gradient-45);}.cls-62{fill:url(#linear-gradient-46);}.cls-63{fill:url(#linear-gradient-47);}.cls-64{fill:url(#linear-gradient-48);}.cls-65{fill:url(#linear-gradient-49);}.cls-66{fill:url(#linear-gradient-50);}.cls-67{fill:url(#linear-gradient-51);}.cls-68{fill:url(#linear-gradient-52);}.cls-69{fill:url(#linear-gradient-53);}.cls-70{fill:url(#linear-gradient-54);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 70.14,
    y1: 666.86,
    x2: 2179.42,
    y2: 666.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 939.12,
    y1: -33.5,
    x2: 420.07,
    y2: 875.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1015.33,
    y1: 10.01,
    x2: 496.28,
    y2: 919.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2175.42,
    y1: 761.58,
    x2: 2010.41,
    y2: 941.07,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2121.86,
    y1: 774.91,
    x2: 2136.52,
    y2: 774.91,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4421b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c0e16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2138.41,
    y1: 727.55,
    x2: 1973.39,
    y2: 907.03,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2069.04,
    y1: 774.16,
    x2: 2081.69,
    y2: 774.16,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1774,
    y1: 305.59,
    x2: 1876,
    y2: 475.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a22b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0423c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1765.87,
    y1: 310.46,
    x2: 1867.87,
    y2: 480.46,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1793.9,
    y1: 353.35,
    x2: 1766.9,
    y2: 319.85,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2018.32,
    y1: 498.59,
    x2: 2113.09,
    y2: 498.59,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2174.38,
    y1: 397,
    x2: 2163.28,
    y2: 445.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2168.57,
    y1: 417.44,
    x2: 2163.26,
    y2: 449.28,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2106.05,
    y1: 488.66,
    x2: 2135.57,
    y2: 488.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 4041.24, 0)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1908.7,
    y1: 351.03,
    x2: 1951.7,
    y2: 448.03,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3877.07,
    y1: -1250.89,
    x2: -3891.07,
    y2: -1191.89,
    gradientTransform: "matrix(-0.75, -0.67, -0.61, 0.68, -1591.07, -1643.77)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3891.81,
    y1: -1254.39,
    x2: -3905.81,
    y2: -1195.39,
    gradientTransform: "matrix(-0.75, -0.67, -0.61, 0.68, -1591.07, -1643.77)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 699.3,
    y1: 1817.32,
    x2: 1287.36,
    y2: 422.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1093.72,
    y1: 879.02,
    x2: 1469.64,
    y2: 879.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1077.14,
    y1: 720.07,
    x2: 1216.25,
    y2: 720.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1077.03,
    y1: 740.01,
    x2: 1216.14,
    y2: 740.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1076.93,
    y1: 760.24,
    x2: 1216.04,
    y2: 760.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 913.05,
    y1: 801.62,
    x2: 1228.5,
    y2: 801.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 912.95,
    y1: 821.56,
    x2: 1228.4,
    y2: 821.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1000.99,
    y1: 889.37,
    x2: 1219.35,
    y2: 889.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1957.79,
    y1: 5644.5,
    x2: -2163.4,
    y2: 5995.42,
    gradientTransform: "matrix(1, -0.03, 0.03, 1, 2842.63, -4988.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1003.4,
    y1: 975.22,
    x2: 1221.76,
    y2: 975.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -1920.08,
    y1: 5666.14,
    x2: -2125.68,
    y2: 6017.06,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1001.87,
    y1: 1057.76,
    x2: 1220.22,
    y2: 1057.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1891.99,
    y1: 5748.47,
    x2: -2162.91,
    y2: 6126.2,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 999.58,
    y1: 1142.89,
    x2: 1217.93,
    y2: 1142.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -1853.18,
    y1: 5705.16,
    x2: -2058.79,
    y2: 6056.08,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 479.59,
    y1: 597.18,
    x2: 336.55,
    y2: 810.14,
    gradientTransform: "matrix(0.7, 0.72, -0.72, 0.7, 857.17, 39.74)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 504.02,
    y1: 613.59,
    x2: 360.97,
    y2: 826.55,
    gradientTransform: "matrix(1, 0.03, -0.03, 1, 283.36, 164.87)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 477.4,
    y1: 685.11,
    x2: 370.52,
    y2: 867.53,
    gradientTransform: "matrix(1, 0.03, -0.03, 1, 283.36, 164.87)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -3106.99,
    y1: 1276.25,
    x2: -3092.37,
    y2: 1276.25,
    gradientTransform: "matrix(-1, 0, 0, 1, -1535.38, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -3199.96,
    y1: 1263.38,
    x2: -3182.48,
    y2: 1263.38,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1647.68,
    y1: 936.71,
    x2: 1613.19,
    y2: 1004.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -3003.27,
    y1: 1016.22,
    x2: -2954.28,
    y2: 1016.22,
    gradientTransform: "matrix(-1, 0, 0, 1, -1535.38, 0)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1496.43,
    y1: 846.97,
    x2: 1530.87,
    y2: 958.26,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1469.38,
    y1: 891.36,
    x2: 1514.05,
    y2: 878.7,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -3422.26,
    y1: 2059.82,
    x2: -3386.14,
    y2: 2022.75,
    gradientTransform: "matrix(-0.99, -0.14, -0.14, 0.99, -1548.5, -1600.1)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -3095.33,
    y1: 1039.59,
    x2: -3157.54,
    y2: 1094.68,
    gradientTransform: "matrix(-1, 0, 0, 1, -1535.38, 0)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -2959.48,
    y1: 1011.3,
    x2: -2941.94,
    y2: 1011.3,
    gradientTransform: "matrix(-1, 0, 0, 1, -1535.38, 0)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -1286.78,
    y1: 1526.39,
    x2: -1251.01,
    y2: 1108.3,
    gradientTransform: "matrix(-1, 0.02, 0.02, 1, -933.4, 50.96)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 323.38,
    y1: 1155.88,
    x2: 285.38,
    y2: 1364.88,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 375.26,
    y1: 1018.96,
    x2: 356.25,
    y2: 1159.96,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 578.47,
    y1: 807.7,
    x2: 519.47,
    y2: 943.7,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1272.02,
    y1: 981.14,
    x2: -1256.62,
    y2: 981.14,
    gradientTransform: "translate(1739.39 7.99) rotate(-0.92)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -2737.29,
    y1: 637.79,
    x2: -2721.29,
    y2: 698.79,
    gradientTransform: "matrix(-0.98, -0.18, -0.18, 0.98, -2143.94, -197)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -2723.31,
    y1: 634.13,
    x2: -2707.31,
    y2: 695.13,
    gradientTransform: "matrix(-0.98, -0.18, -0.18, 0.98, -2143.94, -197)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 256.88,
    y1: 1195.32,
    x2: 421.84,
    y2: 1195.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 261.15,
    y1: 1193.09,
    x2: 419.96,
    y2: 1193.09,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 323.98,
    y1: 1095.12,
    x2: 301.98,
    y2: 1208.12,
    xlinkHref: "#linear-gradient-38"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621,34.53c-28.51,17.39-80,57.66-124.82,117.73C462.78,197,450.84,225.6,419.84,232.8c-22.72,5.29-48.31-4.28-83.41-25.56C261.32,161.71,173.1,192.3,109.24,313.53s-39.77,236,78.1,372.05c86.25,99.54-29.74,100.63-96.8,273.14s27.51,366,338.68,363.72c311.6-2.3,782.63,2.11,782.64,2.11,246,2.31,511.43,44.68,740.12-74.59,82.64-43.1,155.71-109.57,196.27-195.14,53.56-113,35.67-255-35.1-356.67-47.18-67.78-115.09-48.26-171.69-92.86-59.09-46.57-94.63-97.11-10.14-180s149.15-138.71,106.44-248.5C1976.49,19.29,1827.79-1,1664.42,65.73s-360.48,166.5-506,123.06C1009.44,144.35,994.86,24.38,812.78,3.93,772.3-.62,693.21-9.5,621,34.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M899.24,248.6a1.74,1.74,0,0,0,.21-2l-10.27-18.22a91,91,0,0,0,9.64-27.91l19.34-8a1.72,1.72,0,0,0,1.06-1.69l-1.5-25.06a1.73,1.73,0,0,0-1.26-1.55l-20.15-5.62A91.19,91.19,0,0,0,883.41,132l8-19.31a1.72,1.72,0,0,0-.44-1.94L872.2,94.09a1.72,1.72,0,0,0-2-.21L852,104.15a91.11,91.11,0,0,0-27.92-9.64l-8-19.34a1.72,1.72,0,0,0-1.69-1.06l-25,1.5a1.73,1.73,0,0,0-1.56,1.26L782.17,97a91,91,0,0,0-26.56,12.9l-19.32-8a1.69,1.69,0,0,0-1.94.44l-16.66,18.78a1.72,1.72,0,0,0-.21,2l10.27,18.22a91,91,0,0,0-9.64,27.91l-19.34,8a1.72,1.72,0,0,0-1.06,1.69l1.5,25a1.74,1.74,0,0,0,1.26,1.56l20.15,5.62a90.91,90.91,0,0,0,12.91,26.56l-8,19.32A1.73,1.73,0,0,0,726,259l18.78,16.66a1.74,1.74,0,0,0,2,.21l18.21-10.27a91.37,91.37,0,0,0,27.92,9.64l8,19.34a1.74,1.74,0,0,0,1.69,1.06l25.05-1.5a1.73,1.73,0,0,0,1.56-1.26l5.62-20.15a91.22,91.22,0,0,0,26.57-12.91l19.31,8a1.71,1.71,0,0,0,1.94-.45Zm-101-43.95a22.28,22.28,0,1,1,30-9.53A22.29,22.29,0,0,1,798.21,204.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M753.51,213.49a1.25,1.25,0,0,1,1.52-1.94l5.64-.13a1.26,1.26,0,1,1,.06,2.51l-5.73.13a2.19,2.19,0,0,1-1.2-.33A1.37,1.37,0,0,1,753.51,213.49Zm22.1,23.9a2.2,2.2,0,0,1-.54-1.67l.21-2.1a1.26,1.26,0,1,1,2.5.24l-.19,1.89,2.51,1.15a1.26,1.26,0,0,1,.62,1.67,1.25,1.25,0,0,1-1.66.61l-2.72-1.25A2.14,2.14,0,0,1,775.61,237.39Zm-24.45-29.67a1.09,1.09,0,0,1-.23-.39l-2.18-5.89a1.25,1.25,0,1,1,2.35-.87l2.18,5.89a1.25,1.25,0,0,1-.74,1.61A1.27,1.27,0,0,1,751.16,207.72Zm33.18,33.78a1.26,1.26,0,0,1,1.47-2l3.89,1.79L790,241a1.25,1.25,0,1,1,1.81,1.73l-.55.56a2.17,2.17,0,0,1-2.37.35l-4.09-1.88A1.19,1.19,0,0,1,784.34,241.5Zm-8.13-13.17a1.22,1.22,0,0,1-.31-1l.23-2.38c-.66-.53-1.32-1.09-2-1.66a1.25,1.25,0,1,1,1.66-1.88c.78.69,1.59,1.36,2.4,2l.55.42-.38,3.76a1.24,1.24,0,0,1-1.37,1.12A1.2,1.2,0,0,1,776.21,228.33Zm-6.58-9.55h0a51,51,0,0,1-3.93-5.08,1.26,1.26,0,1,1,2.08-1.41,49.84,49.84,0,0,0,3.73,4.84,1.25,1.25,0,0,1-.11,1.77A1.27,1.27,0,0,1,769.63,218.78ZM751.16,197l0,0a1.26,1.26,0,0,1,.18-1.77l4.85-4a1.26,1.26,0,0,1,1.59,2l-4.85,4A1.24,1.24,0,0,1,751.16,197Zm43.1,41.22a1.26,1.26,0,0,1,0-1.7l3.66-3.82.67.14q.81.17,1.62.3a1.25,1.25,0,0,1-.42,2.47l-1-.18-2.7,2.82a1.26,1.26,0,0,1-1.78,0Zm-37.11-50.74a1.26,1.26,0,0,1-.31-.78,51,51,0,0,1,.16-6.43,1.25,1.25,0,1,1,2.5.22,47.86,47.86,0,0,0-.15,6.11,1.26,1.26,0,0,1-1.21,1.3A1.24,1.24,0,0,1,757.15,187.46Zm48.17,48.38A1.23,1.23,0,0,1,805,235a1.25,1.25,0,0,1,1.3-1.2,47.9,47.9,0,0,0,6.11-.13,1.25,1.25,0,0,1,.22,2.5,51.17,51.17,0,0,1-6.43.14A1.26,1.26,0,0,1,805.32,235.84Zm-22.67-28.25a1.25,1.25,0,0,1,1.87-1.67A31.8,31.8,0,0,0,789,210a1.26,1.26,0,1,1-1.52,2,33.77,33.77,0,0,1-4.79-4.39Zm-3.74-5-.13-.18a34.34,34.34,0,0,1-2.84-5.85,1.27,1.27,0,0,1,.74-1.62,1.25,1.25,0,0,1,1.61.74,32.67,32.67,0,0,0,2.63,5.42,1.26,1.26,0,0,1-2,1.49Zm-25.77-31.74a1.26,1.26,0,0,1,1.81-1.74l4.53,4.34a1.23,1.23,0,0,1,0,1.77,1.25,1.25,0,0,1-1.77,0l-4.54-4.33Zm39.47,44.28a1.25,1.25,0,0,1,1.49-2l.79.37a32.28,32.28,0,0,0,4.84,1.78,1.26,1.26,0,1,1-.67,2.42,35.15,35.15,0,0,1-5.22-1.92l-.85-.4A1.24,1.24,0,0,1,792.61,215.11Zm-42.77-49a1.25,1.25,0,0,1-.2-1.35l2.62-5.7a1.26,1.26,0,1,1,2.28,1.05l-2.62,5.7a1.25,1.25,0,0,1-1.66.61A1.1,1.1,0,0,1,749.84,166.11Zm70.44,77.51,0,0-4-4.85a1.26,1.26,0,0,1,.18-1.77,1.23,1.23,0,0,1,1.76.18l4,4.85a1.26,1.26,0,0,1-1.91,1.63Zm-45.73-52.74a1.25,1.25,0,0,1-.3-.62,34.38,34.38,0,0,1-.49-6.48,1.26,1.26,0,1,1,2.51.05,31.83,31.83,0,0,0,.45,6,1.26,1.26,0,0,1-1,1.45A1.24,1.24,0,0,1,774.55,190.88Zm51.28,52.34a1.47,1.47,0,0,1-.24-.4,1.26,1.26,0,0,1,.75-1.61l5.88-2.18a1.25,1.25,0,0,1,.87,2.35l-5.88,2.18A1.27,1.27,0,0,1,825.83,243.22Zm-21.2-24.79a1.23,1.23,0,0,1-.31-.93,1.25,1.25,0,0,1,1.35-1.15,31.87,31.87,0,0,0,6-.09,1.26,1.26,0,1,1,.28,2.5,34.45,34.45,0,0,1-6.5.09A1.22,1.22,0,0,1,804.63,218.43Zm-29.84-40a1.26,1.26,0,0,1-.28-1.1,34.29,34.29,0,0,1,2-6.2,1.25,1.25,0,0,1,1.64-.67,1.26,1.26,0,0,1,.67,1.65,32.25,32.25,0,0,0-1.81,5.75,1.25,1.25,0,0,1-1.49,1A1.33,1.33,0,0,1,774.79,178.42Zm-19.71-23.71a1.25,1.25,0,0,1-.2-1.35l.29-.64a2.24,2.24,0,0,1,.54-.72,2.19,2.19,0,0,1,1.67-.55l4.39.44a1.26,1.26,0,0,1-.24,2.5l-4.17-.42-.2.43a1.25,1.25,0,0,1-1.66.62A1.1,1.1,0,0,1,755.08,154.71Zm80.36,82.51a1.19,1.19,0,0,1-.31-.8l-.15-6.28a1.27,1.27,0,0,1,1.23-1.28,1.25,1.25,0,0,1,1.28,1.23l.14,6.27a1.25,1.25,0,0,1-2.19.86ZM767,154.59a1.3,1.3,0,0,1-.31-1,1.26,1.26,0,0,1,1.38-1.12h.1c1-1.28,2.12-2.52,3.26-3.7a1.26,1.26,0,0,1,1.8,1.75,46.6,46.6,0,0,0-3.51,4l-.43.54-1.47-.15A1.25,1.25,0,0,1,767,154.59Zm12.68,12.33a1.26,1.26,0,0,1-.11-1.53,34.87,34.87,0,0,1,4.09-5,1.26,1.26,0,0,1,1.78,0,1.24,1.24,0,0,1,0,1.78,32.19,32.19,0,0,0-3.79,4.68,1.25,1.25,0,0,1-1.74.35A1.21,1.21,0,0,1,779.63,166.92Zm57.9,59a.27.27,0,0,1-.07-.08,1.25,1.25,0,0,1,.26-1.75c1.09-.82,2.16-1.69,3.18-2.59.5-.45,1-.9,1.48-1.37a1.25,1.25,0,0,1,1.77,0,1.23,1.23,0,0,1,0,1.77q-.76.74-1.56,1.44c-1.07.95-2.19,1.86-3.34,2.72A1.25,1.25,0,0,1,837.53,225.87ZM776,146.32l0,0a1.27,1.27,0,0,1,.19-1.77c1-.81,2.08-1.59,3.16-2.33l0-1.08a1.26,1.26,0,1,1,2.51-.05l.05,2.45-.58.39c-1.22.8-2.41,1.67-3.55,2.58A1.26,1.26,0,0,1,776,146.32ZM788.36,158a.62.62,0,0,1-.09-.12,1.24,1.24,0,0,1,.32-1.74,34.6,34.6,0,0,1,5.67-3.18,1.25,1.25,0,0,1,1,2.29,33.09,33.09,0,0,0-5.26,3A1.25,1.25,0,0,1,788.36,158Zm45.51,47.25a1.25,1.25,0,0,1-.07-1.58,31.88,31.88,0,0,0,3-4.83A1.25,1.25,0,1,1,839,200a34.37,34.37,0,0,1-3.22,5.22,1.27,1.27,0,0,1-1.76.25A1,1,0,0,1,833.87,205.26Zm12.68,11.93a1.24,1.24,0,0,1,0-1.61c.18-.23.37-.46.54-.69l.43-.55,6,.6a1.25,1.25,0,1,1-.24,2.49l-4.66-.46-.15.18a1.24,1.24,0,0,1-1.76.19A.71.71,0,0,1,846.55,217.19Zm-67.11-81.57a1.19,1.19,0,0,1-.31-.8l-.08-3.44a2.16,2.16,0,0,1,.74-1.69,2.32,2.32,0,0,1,.69-.42l1.57-.58a1.26,1.26,0,0,1,.87,2.36l-1.36.5.08,3.21a1.27,1.27,0,0,1-1.23,1.29A1.29,1.29,0,0,1,779.44,135.62ZM799.76,153a1.31,1.31,0,0,1-.28-.55,1.26,1.26,0,0,1,.94-1.51,35,35,0,0,1,6.44-.87,1.25,1.25,0,1,1,.1,2.5,32.61,32.61,0,0,0-6,.82A1.27,1.27,0,0,1,799.76,153Zm58.93,64.66a1.28,1.28,0,0,1-.31-.72,1.26,1.26,0,0,1,1-1.33l2.13-4.65a1.26,1.26,0,1,1,2.28,1.05l-2.2,4.8a2.28,2.28,0,0,1-.54.73,2.2,2.2,0,0,1-1.27.54A1.25,1.25,0,0,1,858.69,217.62Zm-19.44-23.21a1.28,1.28,0,0,1-.27-1.18,30.58,30.58,0,0,0,1.1-5.92,1.27,1.27,0,0,1,1.37-1.14,1.24,1.24,0,0,1,1.13,1.36,34.58,34.58,0,0,1-1.18,6.39,1.26,1.26,0,0,1-2.15.49Zm-51.82-65.89a1.28,1.28,0,0,1-.24-.39,1.27,1.27,0,0,1,.74-1.62l5.46-2a2.31,2.31,0,0,1,1-.12,1.26,1.26,0,0,1-.23,2.5l-5.4,2A1.25,1.25,0,0,1,787.43,128.52Zm24.79,23.93a1.25,1.25,0,0,1,1.13-2.07,34.46,34.46,0,0,1,6.31,1.57,1.26,1.26,0,0,1-.84,2.37,31.79,31.79,0,0,0-5.84-1.46A1.19,1.19,0,0,1,812.22,152.45ZM840.36,182a1.21,1.21,0,0,1-.31-.71,33.23,33.23,0,0,0-1.17-5.91,1.25,1.25,0,1,1,2.4-.72,34,34,0,0,1,1.26,6.38,1.25,1.25,0,0,1-1.12,1.37A1.22,1.22,0,0,1,840.36,182Zm-38.73-45.83-4.19-5.11a1.25,1.25,0,1,1,1.94-1.59l3.36,4.1a1.25,1.25,0,0,1-.09,2.48Zm62.67,70.42a1.25,1.25,0,0,1-.2-1.36l.83-1.81-4.38-4.18a1.23,1.23,0,0,1,0-1.77,1.26,1.26,0,0,1,1.78,0l4.66,4.46a2.23,2.23,0,0,1,.35,2.38l-.92,2a1.26,1.26,0,0,1-1.67.61A1.24,1.24,0,0,1,864.3,206.58Zm-7.37-12.07a1.26,1.26,0,0,1-.3-1.06,49.49,49.49,0,0,0,.71-6.07,1.26,1.26,0,1,1,2.51.13,52.54,52.54,0,0,1-.75,6.39,1.25,1.25,0,0,1-2.17.61ZM824,156.59a1.26,1.26,0,0,1,1.57-1.92,34.13,34.13,0,0,1,5.29,3.78,1.25,1.25,0,1,1-1.64,1.89,32.65,32.65,0,0,0-4.91-3.5A1.26,1.26,0,0,1,824,156.59ZM836.8,170a1.51,1.51,0,0,1-.18-.26,31.71,31.71,0,0,0-3.26-5.07,1.25,1.25,0,1,1,2-1.55,34.44,34.44,0,0,1,3.52,5.47A1.25,1.25,0,0,1,836.8,170Zm-29-34.76a1.28,1.28,0,0,1-.32-.85,1.26,1.26,0,0,1,1.27-1.24,52.69,52.69,0,0,1,6.41.45,1.26,1.26,0,1,1-.33,2.49,47.85,47.85,0,0,0-6.1-.43A1.27,1.27,0,0,1,807.83,135.28ZM857.59,182a1.3,1.3,0,0,1-.31-.74c-.06-.86-.14-1.72-.25-2.57l-.09-.68,3.35-2.75a1.21,1.21,0,0,1,1.76.18,1.26,1.26,0,0,1-.17,1.77l-2.28,1.86c.08.67.14,1.34.19,2a1.25,1.25,0,0,1-1.16,1.34A1.27,1.27,0,0,1,857.59,182Zm-38.18-47.83a1.26,1.26,0,0,1,0-1.7l4.33-4.54a1.26,1.26,0,1,1,1.82,1.74l-4.34,4.53a1.25,1.25,0,0,1-1.77,0Zm20.09,12.65a1.26,1.26,0,0,1,1.75-1.8,54.1,54.1,0,0,1,4.68,4.4,1.26,1.26,0,1,1-1.83,1.72,48.8,48.8,0,0,0-4.45-4.18A1,1,0,0,1,839.5,146.83Zm10.11,11.39-.38-.58c-.4-.6-.81-1.19-1.23-1.78a1.25,1.25,0,1,1,2-1.47c.31.42.61.85.91,1.29l3.36-.08a1.26,1.26,0,1,1,.06,2.51ZM865,173.1a.08.08,0,0,1,0,0,1.24,1.24,0,0,1,.18-1.76l1-.86L865,167.33a1.25,1.25,0,0,1,.74-1.61,1.27,1.27,0,0,1,1.62.74l1.22,3.32a2.19,2.19,0,0,1-.63,2.43l-1.25,1A1.25,1.25,0,0,1,865,173.1Zm1.26-2.45Zm-27.46-29.5a1.31,1.31,0,0,1-.31-1l.62-6.24a1.27,1.27,0,0,1,1.38-1.13,1.25,1.25,0,0,1,1.12,1.37l-.62,6.25a1.25,1.25,0,0,1-1.37,1.12A1.29,1.29,0,0,1,838.8,141.15ZM829,129a1.23,1.23,0,0,1-.2-1.35,1.25,1.25,0,0,1,1.66-.62l5.7,2.62a1.26,1.26,0,1,1-1,2.28l-5.7-2.62A1.14,1.14,0,0,1,829,129Zm34.12,32.9a1.47,1.47,0,0,1-.24-.4l-1.29-3.5-.93,0a1.27,1.27,0,0,1-1.28-1.23,1.25,1.25,0,0,1,1.23-1.28l1.14,0a2.23,2.23,0,0,1,2.11,1.44l1.38,3.71a1.25,1.25,0,0,1-.74,1.61A1.27,1.27,0,0,1,863.09,161.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M798.27,193.69a13.54,13.54,0,0,1-2.36-3.79,1.25,1.25,0,1,1,2.31-1,11.12,11.12,0,0,0,3.37,4.44,1.25,1.25,0,0,1-1.55,2A14.62,14.62,0,0,1,798.27,193.69Zm7.3,4a1.25,1.25,0,0,1,1.13-2.07,10.85,10.85,0,0,0,5.53-.58,1.26,1.26,0,0,1,.89,2.35,13.46,13.46,0,0,1-6.8.71A1.3,1.3,0,0,1,805.57,197.66Zm-10.28-13.55a1.25,1.25,0,0,1-.31-1c0-.27.08-.55.13-.83a13.24,13.24,0,0,1,2.39-5.53,1.26,1.26,0,1,1,2,1.49,10.81,10.81,0,0,0-1.94,4.49c-.05.23-.08.46-.11.68a1.26,1.26,0,0,1-1.4,1.1A1.24,1.24,0,0,1,795.29,184.11Zm21.51,9.31a1.23,1.23,0,0,1,0-1.63,11.13,11.13,0,0,0,2.37-5,10.86,10.86,0,0,0,.16-1.37,1.26,1.26,0,0,1,2.51.15,12.24,12.24,0,0,1-.21,1.68,13.48,13.48,0,0,1-2.91,6.19,1.25,1.25,0,0,1-1.77.15Zm-14.41-19a1.1,1.1,0,0,1-.2-.31,1.26,1.26,0,0,1,.63-1.66,13.36,13.36,0,0,1,6.74-1.14,1.25,1.25,0,1,1-.22,2.5,11,11,0,0,0-5.49.92A1.25,1.25,0,0,1,802.39,174.43Zm16,5.77a1.52,1.52,0,0,1-.19-.28,11.12,11.12,0,0,0-3.63-4.22,1.25,1.25,0,1,1,1.42-2.06,13.56,13.56,0,0,1,4.47,5.18,1.26,1.26,0,0,1-2.07,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M816.87,258.78a1.3,1.3,0,0,1-.31-.67,1.26,1.26,0,0,1,1.09-1.41c1-.13,2-.28,3.05-.46a1.26,1.26,0,0,1,.42,2.48c-1,.18-2.09.34-3.15.47A1.23,1.23,0,0,1,816.87,258.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M752.18,234.53c-1.36-1.55-2.68-3.16-3.91-4.81a1.25,1.25,0,0,1,2-1.5c1.19,1.59,2.46,3.15,3.78,4.64l.26.3h0a1.26,1.26,0,0,1-1.87,1.68Zm4.81,4.94a1.25,1.25,0,0,1,1.8-1.74c1.55,1.45,3.18,2.84,4.85,4.15a1.26,1.26,0,0,1-1.55,2c-1.73-1.36-3.42-2.8-5-4.3Zm-12.32-15-.12-.18c-1.16-1.87-2.25-3.81-3.23-5.76a1.24,1.24,0,0,1,.55-1.68,1.27,1.27,0,0,1,1.69.55c1,1.89,2,3.76,3.12,5.57a1.26,1.26,0,0,1-2,1.5Zm22.54,23a1.25,1.25,0,0,1,1.62-1.88c1.78,1.15,3.63,2.24,5.51,3.24a1.25,1.25,0,1,1-1.18,2.21c-1.94-1-3.85-2.15-5.7-3.35A1.31,1.31,0,0,1,767.21,247.48Zm-28.38-34.63a1.28,1.28,0,0,1-.23-.37c-.81-2-1.55-4.14-2.17-6.24a1.25,1.25,0,0,1,2.4-.72c.61,2,1.31,4.06,2.1,6a1.25,1.25,0,0,1-2.1,1.3Zm39.85,40.71a1.25,1.25,0,0,1,1.42-2c2,.83,4,1.57,6,2.22a1.25,1.25,0,0,1-.76,2.39c-2.09-.67-4.18-1.44-6.2-2.29A1.25,1.25,0,0,1,778.68,253.56ZM735.1,200.42a1.33,1.33,0,0,1-.29-.58c-.44-2.15-.79-4.35-1-6.52a1.25,1.25,0,1,1,2.49-.29c.24,2.11.58,4.22,1,6.31a1.26,1.26,0,0,1-1,1.48A1.28,1.28,0,0,1,735.1,200.42ZM791,257.53a1.25,1.25,0,0,1,1.22-2c.94.21,1.89.41,2.85.58,1.15.22,2.29.4,3.43.56a1.25,1.25,0,1,1-.34,2.48c-1.18-.16-2.38-.35-3.55-.57-1-.18-2-.39-2.95-.61A1.23,1.23,0,0,1,791,257.53Zm-57.42-70a1.19,1.19,0,0,1-.31-.8c-.06-2.18,0-4.41.12-6.6a1.25,1.25,0,1,1,2.5.16c-.13,2.12-.17,4.27-.12,6.38a1.25,1.25,0,0,1-2.19.86Zm70.28,71.76a1.22,1.22,0,0,1-.31-.89,1.25,1.25,0,0,1,1.31-1.19c2.12.1,4.27.11,6.39,0a1.26,1.26,0,1,1,.09,2.51c-2.19.08-4.41.07-6.6,0A1.21,1.21,0,0,1,803.9,259.29Zm-69.47-84.71a1.24,1.24,0,0,1-.3-1q.2-1.26.42-2.52c.25-1.32.53-2.65.85-4a1.25,1.25,0,1,1,2.44.58c-.31,1.27-.58,2.56-.82,3.83-.15.82-.29,1.63-.41,2.44a1.26,1.26,0,0,1-1.43,1.06A1.3,1.3,0,0,1,734.43,174.58ZM737.48,162a1.24,1.24,0,0,1-.25-1.23c.7-2.08,1.5-4.16,2.38-6.17a1.26,1.26,0,0,1,2.3,1c-.86,1.94-1.63,4-2.3,6a1.27,1.27,0,0,1-1.59.79A1.29,1.29,0,0,1,737.48,162Zm5.2-11.89a1.27,1.27,0,0,1-.16-1.44c1.06-1.92,2.21-3.82,3.44-5.64a1.25,1.25,0,1,1,2.08,1.39c-1.18,1.76-2.3,3.6-3.32,5.46a1.25,1.25,0,0,1-1.7.5A1.5,1.5,0,0,1,742.68,150.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M750,139.22a1.26,1.26,0,0,1,0-1.62c.67-.83,1.36-1.64,2.06-2.43a1.25,1.25,0,1,1,1.88,1.65c-.68.77-1.34,1.56-2,2.36a1.25,1.25,0,0,1-1.76.19A1.06,1.06,0,0,1,750,139.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M801,112a1.2,1.2,0,0,1-.3-.72,1.26,1.26,0,0,1,1.14-1.36c1-.09,2.12-.16,3.18-.21a1.26,1.26,0,1,1,.11,2.51c-1,0-2.06.11-3.08.2A1.27,1.27,0,0,1,801,112Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M866.73,229.5a1.26,1.26,0,0,1-.07-1.58c1.25-1.68,2.43-3.43,3.52-5.2a1.25,1.25,0,0,1,2.14,1.31c-1.13,1.84-2.35,3.65-3.64,5.39a1.27,1.27,0,0,1-1.76.26Zm6.69-10.88a1.24,1.24,0,0,1-.18-1.39c.93-1.87,1.79-3.8,2.56-5.74a1.25,1.25,0,1,1,2.33.92c-.79,2-1.68,4-2.65,5.94a1.25,1.25,0,0,1-1.68.56A1.24,1.24,0,0,1,873.42,218.62Zm4.7-11.88a1.27,1.27,0,0,1-.27-1.19c.6-2,1.12-4,1.54-6.1a1.26,1.26,0,0,1,2.46.51c-.44,2.13-1,4.25-1.59,6.31a1.25,1.25,0,0,1-2.14.47Zm2.59-12.51a1.27,1.27,0,0,1-.31-1c.25-2.08.41-4.19.47-6.27a1.27,1.27,0,0,1,1.3-1.21,1.25,1.25,0,0,1,1.21,1.3c-.07,2.14-.23,4.32-.49,6.48a1.24,1.24,0,0,1-1.39,1.09A1.2,1.2,0,0,1,880.71,194.23Zm-70.14-82.41a1.25,1.25,0,0,1,1-2.08c2.15.09,4.33.28,6.48.56a1.26,1.26,0,0,1-.33,2.49c-2.07-.27-4.18-.45-6.26-.55A1.21,1.21,0,0,1,810.57,111.82Zm70.55,69.65a1.28,1.28,0,0,1-.32-.76c-.11-2.09-.32-4.19-.61-6.25a1.25,1.25,0,1,1,2.48-.35c.31,2.12.52,4.3.64,6.46a1.25,1.25,0,0,1-2.19.9Zm-57.88-68a1.24,1.24,0,0,1-.29-1.1,1.25,1.25,0,0,1,1.49-1c2.11.46,4.22,1,6.29,1.66a1.26,1.26,0,0,1-.74,2.4c-2-.62-4-1.16-6.08-1.61A1.26,1.26,0,0,1,823.24,113.48Zm56.07,55.35a1.27,1.27,0,0,1-.28-.54c-.47-2-1-4.06-1.69-6a1.25,1.25,0,1,1,2.38-.78c.68,2,1.26,4.16,1.75,6.26a1.26,1.26,0,0,1-.93,1.51A1.27,1.27,0,0,1,879.31,168.83Zm-43.88-51.56a1.26,1.26,0,0,1,1.42-2c2,.82,4,1.73,5.9,2.72a1.25,1.25,0,0,1-1.15,2.23c-1.85-1-3.77-1.84-5.7-2.63A1.22,1.22,0,0,1,835.43,117.27Zm39.91,39.43a1.3,1.3,0,0,1-.21-.34c-.82-1.92-1.73-3.82-2.71-5.67a1.26,1.26,0,1,1,2.22-1.18c1,1.91,2,3.88,2.8,5.87a1.26,1.26,0,0,1-2.1,1.32Zm-28.55-33.58a1.25,1.25,0,0,1,1.61-1.89c1.82,1.15,3.62,2.4,5.34,3.7a1.26,1.26,0,0,1-1.52,2c-1.66-1.26-3.4-2.46-5.16-3.58A.87.87,0,0,1,846.79,123.12Zm22.56,22.31-.12-.15c-1.14-1.76-2.36-3.48-3.64-5.12a1.25,1.25,0,1,1,2-1.54c1.32,1.69,2.59,3.48,3.77,5.29a1.26,1.26,0,0,1-2,1.52ZM857,130.85a1.26,1.26,0,0,1,1.79-1.76c1.6,1.45,3.15,3,4.62,4.57a1.28,1.28,0,0,1-.07,1.77,1.24,1.24,0,0,1-1.77-.06c-1.42-1.53-2.92-3-4.47-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M860.52,236.82a1.25,1.25,0,0,1,0-1.7c.72-.74,1.41-1.5,2.1-2.26a1.25,1.25,0,1,1,1.87,1.66c-.7.8-1.43,1.58-2.16,2.34a1.26,1.26,0,0,1-1.78,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M593.49,1281.33S388.7,761.92,11.83,526.13a7.09,7.09,0,0,0-11.09,5.8C-3.66,623.68-7.61,1206,593.49,1281.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.1,674.38c14.39,29.1,29.89,57.79,46.32,85.83q24.42,42.22,51,83c17.79,27.14,36.08,53.92,55.26,80s38.79,51.82,59.43,76.63,41.68,49.27,63.83,72.59c2.74,2.94,5.45,5.91,8.23,8.82l8.42,8.61c5.65,5.7,11.17,11.56,16.92,17.14l17.27,16.75,4.31,4.2,4.41,4.07,8.83,8.13c11.63,11,23.91,21.23,35.9,31.82,6.08,5.18,12.31,10.13,18.46,15.22l9.26,7.58c3.11,2.49,6.32,4.83,9.45,7.29l18.91,14.61,19.35,13.9,9.69,6.94,9.9,6.56L572,1257.37l.06,0a2.44,2.44,0,0,1,.82,3.12,2,2,0,0,1-2.76.71,938.35,938.35,0,0,1-155.56-112.38l-9.09-8-4.54-4-4.44-4.15L378.84,1116c-5.88-5.57-11.53-11.41-17.31-17.1l-8.62-8.6c-2.84-2.9-5.61-5.87-8.43-8.8-22.61-23.34-44-48-64.86-73A1494.9,1494.9,0,0,1,165.35,849.3q-26-41.61-49.24-84.92-11.56-21.66-22.35-43.71C86.54,706,79.61,691.18,73.28,676a2.15,2.15,0,0,1,1-2.89,2.21,2.21,0,0,1,2.74,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M561.21,789.83s-110.56-488.74-356-755.54c-16.49-17.94-47.59-11.06-54.76,12.18C102.51,201.9,6.67,673.39,561.21,789.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M510.91,758.27c1.23,1.17-.47,3-1.85,2C458.18,723.54,262.29,543,196.35,183.58a1,1,0,0,1,1.9-.46C221.52,266.45,317.38,573.71,510.91,758.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1677.5,1297.79s129.7-534.68,402.41-827.28c18.33-19.66,52.13-12.27,59.52,13.12C2188.9,653.34,2284.73,1168.39,1677.5,1297.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1697.17,1307.71A1.47,1.47,0,0,0,1699,1310c58.88-36.71,289.22-220.6,394.89-607.92a1.06,1.06,0,0,0-2-.63C2058.67,790.74,1925.32,1119.26,1697.17,1307.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1640.3,1311.74s47.82-613,297.24-981.46c16.77-24.77,55.5-22.12,68.23,4.76C2090.9,514.77,2289.17,1069.08,1640.3,1311.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1695.47,1264.27c-1.27,1.64,1.1,3.56,2.59,2.1,55-53.87,259.77-308.65,276.37-756.65a1.19,1.19,0,0,0-2.36-.22C1958.58,614.82,1896.71,1005,1695.47,1264.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1896.88,228l22.4,1.14A20.8,20.8,0,0,1,1939,250l-1.64,460.59a21.81,21.81,0,0,1-22,21.75l-153.83-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1628.26,231.6l283.78-17a10.07,10.07,0,0,1,10.67,10.26l-11.14,476.88a21,21,0,0,1-21.65,20.62l-199.66-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1643.56,242.94l249.35-34.77a10.58,10.58,0,0,1,12,10.59l-5.72,481.54a14.63,14.63,0,0,1-14,14.47l-183.66,7.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1577.6,216.24,1851.19,196a23.71,23.71,0,0,1,25.46,23.37l6.56,493.09a20.71,20.71,0,0,1-20.47,20.95l-252.43,2.94a22.42,22.42,0,0,1-22.63-21l-35.44-470A27.44,27.44,0,0,1,1577.6,216.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1883.09,417.83l-8.26.1a17.16,17.16,0,0,1-17.35-17l-1.56-134a17.15,17.15,0,0,1,16.95-17.35l8.26-.1a17.15,17.15,0,0,1,17.35,16.95l1.56,134A17.15,17.15,0,0,1,1883.09,417.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1714,138.76l25.23,1.28a23.43,23.43,0,0,1,22.23,23.47l-1.84,518.8a24.56,24.56,0,0,1-24.81,24.49l-173.28-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1411.47,142.78l319.64-19.18a11.34,11.34,0,0,1,12,11.55l-12.55,537.16a23.71,23.71,0,0,1-24.39,23.22l-224.9-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1428.69,155.55l280.87-39.16a11.92,11.92,0,0,1,13.57,11.93l-6.44,542.39a16.48,16.48,0,0,1-15.81,16.3L1494,695.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1354.4,125.48l308.17-22.79A26.71,26.71,0,0,1,1691.24,129l7.4,555.41a23.34,23.34,0,0,1-23.06,23.6l-284.34,3.31a25.24,25.24,0,0,1-25.48-23.6l-39.93-529.4A30.91,30.91,0,0,1,1354.4,125.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1702.49,352.5l-17.29.2a15.32,15.32,0,0,1-15.5-15.15l-1.85-159a15.32,15.32,0,0,1,15.14-15.5l17.29-.2A15.32,15.32,0,0,1,1715.79,178l1.85,159A15.34,15.34,0,0,1,1702.49,352.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 210.9,
    y: 1290.24,
    width: 1177.21,
    height: 34.11,
    transform: "translate(1599.01 2614.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 199.14,
    y: 918.53,
    width: 1198.18,
    height: 32.71,
    transform: "translate(1596.46 1869.77) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 206.33,
    y: 559.68,
    width: 1186.34,
    height: 30.02,
    transform: "translate(1599.01 1149.39) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.4,296h36.38a0,0,0,0,1,0,0V1355.59a0,0,0,0,1,0,0H208A25.62,25.62,0,0,1,182.4,1330V296A0,0,0,0,1,182.4,296Z",
    transform: "translate(401.19 1651.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1367,282h40.17a0,0,0,0,1,0,0V1310.94a27.93,27.93,0,0,1-27.93,27.93H1367a0,0,0,0,1,0,0V282A0,0,0,0,1,1367,282Z",
    transform: "translate(2774.15 1620.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 443.84,
    y: 217.27,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 501.61,
    cy: 400.2,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 501.61,
    cy: 400.2,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 467.67,
    y: 234.34,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.5,317.42H472.83a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9H525.5a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,525.5,317.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.5,336H472.83a1.9,1.9,0,0,1-1.9-1.89h0a1.9,1.9,0,0,1,1.9-1.9H525.5a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,525.5,336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.5,266.24H472.83a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9H525.5a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,525.5,266.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.5,283.3H472.83a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9H525.5a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,525.5,283.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M526.8,300.36H474.13a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9H526.8a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,526.8,300.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 468.65,
    y: 442.94,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M526.61,520.28H473.67a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,526.61,520.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M526.61,537.55H473.67a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,526.61,537.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M526.61,472.64H473.67a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,526.61,472.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M526.61,488.52H473.67a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,526.61,488.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M527.91,504.4H475a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,527.91,504.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 555.18,
    y: 216.66,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 612.95,
    cy: 399.58,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 612.95,
    cy: 399.58,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 579.01,
    y: 233.72,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.84,316.81H584.17a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,636.84,316.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.84,335.37H584.17a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,636.84,335.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.84,265.63H584.17a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,636.84,265.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M636.84,282.69H584.17a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,636.84,282.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M638.14,299.75H585.47a1.9,1.9,0,0,1-1.89-1.9h0a1.89,1.89,0,0,1,1.89-1.89h52.67a1.9,1.9,0,0,1,1.9,1.89h0A1.91,1.91,0,0,1,638.14,299.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 579.99,
    y: 442.33,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M638,519.66H585a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77H638a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,638,519.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M638,536.94H585a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76H638a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,638,536.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M638,472H585a1.77,1.77,0,0,1-1.76-1.77h0A1.76,1.76,0,0,1,585,468.5H638a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,638,472Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M638,487.91H585a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76H638a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,638,487.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M639.25,503.78H586.32a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.93A1.77,1.77,0,0,1,641,502h0A1.77,1.77,0,0,1,639.25,503.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 673.19,
    y: 217.58,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 730.96,
    cy: 400.51,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 730.96,
    cy: 400.51,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 697.02,
    y: 234.64,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M754.85,317.73H702.18a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,754.85,317.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M754.85,336.29H702.18a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,754.85,336.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M754.85,266.55H702.18a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,754.85,266.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M754.85,283.61H702.18a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,754.85,283.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756.15,300.67H703.48a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.9,1.9,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,756.15,300.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 698,
    y: 443.25,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756,520.59H703a1.78,1.78,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.76H756a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,756,520.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756,537.86H703a1.77,1.77,0,0,1-1.77-1.76h0a1.78,1.78,0,0,1,1.77-1.77H756a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,756,537.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756,473H703a1.77,1.77,0,0,1-1.77-1.76h0a1.78,1.78,0,0,1,1.77-1.77H756a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,756,473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M756,488.83H703a1.77,1.77,0,0,1-1.77-1.76h0A1.78,1.78,0,0,1,703,485.3H756a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,756,488.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M757.26,504.71H704.33a1.76,1.76,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,757.26,504.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 791.39,
    y: 216.97,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 849.15,
    cy: 399.89,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 849.15,
    cy: 399.89,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 815.21,
    y: 234.03,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M873,317.12H820.37a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9H873a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,873,317.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M873,335.67H820.37a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9H873a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,873,335.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M873,265.94H820.37a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9H873a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,873,265.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M873,283H820.37a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9H873a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,873,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.35,300.06H821.68a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,874.35,300.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 816.19,
    y: 442.64,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.15,520H821.22a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,874.15,520Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.15,537.24H821.22a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,874.15,537.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.15,472.34H821.22a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.78,1.78,0,0,1,874.15,472.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M874.15,488.21H821.22a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,874.15,488.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M875.46,504.09H822.52a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,875.46,504.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 906.42,
    y: 217.58,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 964.19,
    cy: 400.51,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 964.19,
    cy: 400.51,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 930.25,
    y: 234.64,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M988.07,317.73H935.4a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.9,1.9,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,988.07,317.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M988.07,336.29H935.4a1.9,1.9,0,0,1-1.89-1.9h0a1.89,1.89,0,0,1,1.89-1.89h52.67a1.9,1.9,0,0,1,1.9,1.89h0A1.9,1.9,0,0,1,988.07,336.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M988.07,266.55H935.4a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.9,1.9,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,988.07,266.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M988.07,283.61H935.4a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.9,1.9,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,988.07,283.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M989.38,300.67H936.71a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,989.38,300.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 931.22,
    y: 443.25,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M989.18,520.59H936.25a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.78,1.78,0,0,1,989.18,520.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M989.18,537.86H936.25a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93A1.78,1.78,0,0,1,991,536.1h0A1.77,1.77,0,0,1,989.18,537.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M989.18,473H936.25a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,989.18,473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M989.18,488.83H936.25a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,989.18,488.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M990.49,504.71H937.56a1.77,1.77,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.76h52.93a1.76,1.76,0,0,1,1.76,1.76h0A1.76,1.76,0,0,1,990.49,504.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1017.76,
    y: 216.97,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1075.53,
    cy: 399.89,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1075.53,
    cy: 399.89,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1041.58,
    y: 234.03,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1099.41,317.12h-52.67a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,1099.41,317.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1099.41,335.67h-52.67a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,1099.41,335.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1099.41,265.94h-52.67a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,1099.41,265.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1099.41,283h-52.67a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,1099.41,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1100.72,300.06h-52.67a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,1100.72,300.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1042.56,
    y: 442.64,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1100.52,520h-52.93a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,1100.52,520Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1100.52,537.24h-52.93a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,1100.52,537.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1100.52,472.34h-52.93a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.78,1.78,0,0,1,1100.52,472.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1100.52,488.21h-52.93a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,1100.52,488.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1101.83,504.09H1048.9a1.77,1.77,0,0,1-1.77-1.76h0a1.78,1.78,0,0,1,1.77-1.77h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,1101.83,504.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1135.6,
    y: 217.58,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1193.37,
    cy: 400.51,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1193.37,
    cy: 400.51,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1159.43,
    y: 234.64,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.26,317.73h-52.67a1.9,1.9,0,0,1-1.9-1.89h0a1.9,1.9,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,1217.26,317.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.26,336.29h-52.67a1.9,1.9,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,1217.26,336.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.26,266.55h-52.67a1.9,1.9,0,0,1-1.9-1.89h0a1.9,1.9,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,1217.26,266.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1217.26,283.61h-52.67a1.9,1.9,0,0,1-1.9-1.89h0a1.9,1.9,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,1217.26,283.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1218.56,300.67h-52.67a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,1218.56,300.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1160.41,
    y: 443.25,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1218.37,520.59h-52.94a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.94a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,1218.37,520.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1218.37,537.86h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,1218.37,537.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1218.37,473h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,1218.37,473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1218.37,488.83h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,1218.37,488.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1219.67,504.71h-52.93a1.76,1.76,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.77,1.77,0,0,1,1219.67,504.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1246.94,
    y: 216.97,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1304.71,
    cy: 399.89,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1304.71,
    cy: 399.89,
    rx: 15.83,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1270.77,
    y: 234.03,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1328.6,317.12h-52.67a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,1328.6,317.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1328.6,335.67h-52.67a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,1328.6,335.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1328.6,265.94h-52.67a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,1328.6,265.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1328.6,283h-52.67a1.91,1.91,0,0,1-1.9-1.9h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.9,1.9,0,0,1,1328.6,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1329.9,300.06h-52.67a1.9,1.9,0,0,1-1.89-1.9h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.91,1.91,0,0,1,1329.9,300.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1271.75,
    y: 442.64,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1329.71,520h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.94a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,1329.71,520Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1329.71,537.24h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.94a1.76,1.76,0,0,1,1.76,1.76h0A1.76,1.76,0,0,1,1329.71,537.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1329.71,472.34h-52.94a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.94a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,1329.71,472.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1329.71,488.21h-52.94a1.76,1.76,0,0,1-1.76-1.76h0a1.76,1.76,0,0,1,1.76-1.76h52.94a1.76,1.76,0,0,1,1.76,1.76h0A1.76,1.76,0,0,1,1329.71,488.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1331,504.09h-52.93a1.77,1.77,0,0,1-1.77-1.76h0a1.78,1.78,0,0,1,1.77-1.77H1331a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,1331,504.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 221.52,
    y: 217.89,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 279.29,
    cy: 400.81,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 279.29,
    cy: 400.81,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 245.35,
    y: 234.95,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.18,318H250.51a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,303.18,318Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.18,336.6H250.51a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,303.18,336.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.18,266.86H250.51a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,303.18,266.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.18,283.92H250.51a1.91,1.91,0,0,1-1.9-1.9h0a1.9,1.9,0,0,1,1.9-1.89h52.67a1.89,1.89,0,0,1,1.89,1.89h0A1.9,1.9,0,0,1,303.18,283.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.48,301H251.81a1.9,1.9,0,0,1-1.89-1.9h0a1.89,1.89,0,0,1,1.89-1.89h52.67a1.9,1.9,0,0,1,1.9,1.89h0A1.9,1.9,0,0,1,304.48,301Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 246.33,
    y: 443.56,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.29,520.9H251.36a1.78,1.78,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.76h52.93a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,304.29,520.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.29,538.17H251.36a1.78,1.78,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.76h52.93a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,304.29,538.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.29,473.26H251.36a1.77,1.77,0,0,1-1.77-1.76h0a1.78,1.78,0,0,1,1.77-1.77h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,304.29,473.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.29,489.14H251.36a1.78,1.78,0,0,1-1.77-1.77h0a1.77,1.77,0,0,1,1.77-1.76h52.93a1.76,1.76,0,0,1,1.76,1.76h0A1.77,1.77,0,0,1,304.29,489.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M305.59,505H252.66a1.77,1.77,0,0,1-1.76-1.77h0a1.76,1.76,0,0,1,1.76-1.76h52.93a1.77,1.77,0,0,1,1.77,1.76h0A1.78,1.78,0,0,1,305.59,505Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 332.86,
    y: 217.27,
    width: 116.53,
    height: 352.58,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 390.63,
    cy: 400.2,
    rx: 20.56,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 390.63,
    cy: 400.2,
    rx: 15.84,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 356.69,
    y: 234.34,
    width: 65.6,
    height: 125.11,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.52,317.42H361.85a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,414.52,317.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.52,336H361.85a1.9,1.9,0,0,1-1.9-1.89h0a1.9,1.9,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,414.52,336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.52,266.24H361.85a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,414.52,266.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M414.52,283.3H361.85a1.9,1.9,0,0,1-1.9-1.89h0a1.91,1.91,0,0,1,1.9-1.9h52.67a1.9,1.9,0,0,1,1.89,1.9h0A1.89,1.89,0,0,1,414.52,283.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M415.82,300.36H363.15a1.89,1.89,0,0,1-1.89-1.89h0a1.9,1.9,0,0,1,1.89-1.9h52.67a1.91,1.91,0,0,1,1.9,1.9h0A1.9,1.9,0,0,1,415.82,300.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 357.67,
    y: 442.94,
    width: 65.6,
    height: 116.44,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M415.63,520.28H362.7a1.76,1.76,0,0,1-1.77-1.76h0a1.77,1.77,0,0,1,1.77-1.77h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,415.63,520.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M415.63,537.55H362.7a1.76,1.76,0,0,1-1.77-1.76h0A1.77,1.77,0,0,1,362.7,534h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,415.63,537.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M415.63,472.64H362.7a1.76,1.76,0,0,1-1.77-1.76h0a1.77,1.77,0,0,1,1.77-1.77h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,415.63,472.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M415.63,488.52H362.7a1.76,1.76,0,0,1-1.77-1.76h0A1.77,1.77,0,0,1,362.7,485h52.93a1.77,1.77,0,0,1,1.76,1.77h0A1.76,1.76,0,0,1,415.63,488.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M416.93,504.4H364a1.76,1.76,0,0,1-1.76-1.76h0a1.77,1.77,0,0,1,1.76-1.77h52.93a1.78,1.78,0,0,1,1.77,1.77h0A1.77,1.77,0,0,1,416.93,504.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 217.86,
    y: 600.92,
    width: 107.1,
    height: 324.04,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 270.95,
    cy: 769.04,
    rx: 18.9,
    ry: 18.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 270.95,
    cy: 769.04,
    rx: 14.55,
    ry: 14.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 238.36,
    y: 616.6,
    width: 61.69,
    height: 143.37,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.74,711.82H243.21a2,2,0,0,1-1.78-2.17h0a2,2,0,0,1,1.78-2.18h49.53a2,2,0,0,1,1.78,2.18h0A2,2,0,0,1,292.74,711.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.74,733.08H243.21a2,2,0,0,1-1.78-2.17h0a2,2,0,0,1,1.78-2.17h49.53a2,2,0,0,1,1.78,2.17h0A2,2,0,0,1,292.74,733.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.74,653.17H243.21a2,2,0,0,1-1.78-2.18h0a2,2,0,0,1,1.78-2.17h49.53a2,2,0,0,1,1.78,2.17h0A2,2,0,0,1,292.74,653.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.74,672.72H243.21a2,2,0,0,1-1.78-2.17h0a2,2,0,0,1,1.78-2.18h49.53a2,2,0,0,1,1.78,2.18h0A2,2,0,0,1,292.74,672.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M294,692.27H244.44a2,2,0,0,1-1.79-2.17h0a2,2,0,0,1,1.79-2.18H294a2,2,0,0,1,1.79,2.18h0A2,2,0,0,1,294,692.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 240.65,
    y: 808.33,
    width: 60.29,
    height: 107.02,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.92,879.4H245.28a1.63,1.63,0,0,1-1.63-1.62h0a1.63,1.63,0,0,1,1.63-1.62h48.64a1.62,1.62,0,0,1,1.62,1.62h0A1.62,1.62,0,0,1,293.92,879.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.92,895.28H245.28a1.63,1.63,0,0,1-1.63-1.63h0a1.63,1.63,0,0,1,1.63-1.62h48.64a1.62,1.62,0,0,1,1.62,1.62h0A1.62,1.62,0,0,1,293.92,895.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 243.65,
    y: 832.38,
    width: 51.89,
    height: 3.24,
    rx: 1.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.92,850.21H245.28a1.62,1.62,0,0,1-1.63-1.62h0a1.63,1.63,0,0,1,1.63-1.62h48.64a1.62,1.62,0,0,1,1.62,1.62h0A1.61,1.61,0,0,1,293.92,850.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M295.12,864.81H246.48a1.63,1.63,0,0,1-1.63-1.62h0a1.63,1.63,0,0,1,1.63-1.62h48.64a1.63,1.63,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,295.12,864.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 320.19,
    y: 600.35,
    width: 107.1,
    height: 324.04,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 373.28,
    cy: 768.47,
    rx: 18.9,
    ry: 18.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 373.28,
    cy: 768.47,
    rx: 14.55,
    ry: 14.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 342.08,
    y: 616.03,
    width: 60.29,
    height: 114.98,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.23,692.4H346.82a1.75,1.75,0,0,1-1.74-1.74h0a1.76,1.76,0,0,1,1.74-1.75h48.41a1.75,1.75,0,0,1,1.74,1.75h0A1.75,1.75,0,0,1,395.23,692.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.23,709.45H346.82a1.75,1.75,0,0,1-1.74-1.74h0a1.75,1.75,0,0,1,1.74-1.74h48.41a1.74,1.74,0,0,1,1.74,1.74h0A1.74,1.74,0,0,1,395.23,709.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.23,645.36H346.82a1.75,1.75,0,0,1-1.74-1.74h0a1.75,1.75,0,0,1,1.74-1.74h48.41a1.74,1.74,0,0,1,1.74,1.74h0A1.74,1.74,0,0,1,395.23,645.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.23,661H346.82a1.75,1.75,0,0,1-1.74-1.74h0a1.75,1.75,0,0,1,1.74-1.74h48.41A1.74,1.74,0,0,1,397,659.3h0A1.74,1.74,0,0,1,395.23,661Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.43,676.72H348a1.75,1.75,0,0,1-1.74-1.74h0a1.76,1.76,0,0,1,1.74-1.75h48.41a1.75,1.75,0,0,1,1.74,1.75h0A1.75,1.75,0,0,1,396.43,676.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 342.98,
    y: 807.76,
    width: 60.29,
    height: 107.02,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.25,878.84H347.6a1.63,1.63,0,0,1-1.62-1.63h0a1.63,1.63,0,0,1,1.62-1.62h48.65a1.63,1.63,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,396.25,878.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.25,894.71H347.6a1.63,1.63,0,0,1-1.62-1.62h0a1.63,1.63,0,0,1,1.62-1.62h48.65a1.63,1.63,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,396.25,894.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.25,835.05H347.6a1.63,1.63,0,0,1-1.62-1.62h0a1.63,1.63,0,0,1,1.62-1.62h48.65a1.63,1.63,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,396.25,835.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.25,849.65H347.6A1.63,1.63,0,0,1,346,848h0a1.62,1.62,0,0,1,1.62-1.62h48.65a1.62,1.62,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,396.25,849.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M397.45,864.24H348.8a1.63,1.63,0,0,1-1.62-1.62h0A1.63,1.63,0,0,1,348.8,861h48.65a1.63,1.63,0,0,1,1.62,1.62h0A1.63,1.63,0,0,1,397.45,864.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 218.09,
    y: 970.68,
    width: 106.1,
    height: 321.01,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 270.69,
    cy: 1137.22,
    rx: 18.72,
    ry: 18.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 270.69,
    cy: 1137.22,
    rx: 14.42,
    ry: 13.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 239.78,
    y: 986.21,
    width: 59.73,
    height: 113.91,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.43,1061.86h-48a1.74,1.74,0,0,1-1.73-1.73h0a1.73,1.73,0,0,1,1.73-1.72h48a1.73,1.73,0,0,1,1.73,1.72h0A1.74,1.74,0,0,1,292.43,1061.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.43,1078.76h-48a1.74,1.74,0,0,1-1.73-1.73h0a1.74,1.74,0,0,1,1.73-1.73h48a1.74,1.74,0,0,1,1.73,1.73h0A1.74,1.74,0,0,1,292.43,1078.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.43,1015.26h-48a1.73,1.73,0,0,1-1.73-1.72h0a1.74,1.74,0,0,1,1.73-1.73h48a1.74,1.74,0,0,1,1.73,1.73h0A1.73,1.73,0,0,1,292.43,1015.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.43,1030.79h-48a1.73,1.73,0,0,1-1.73-1.72h0a1.74,1.74,0,0,1,1.73-1.73h48a1.74,1.74,0,0,1,1.73,1.73h0A1.73,1.73,0,0,1,292.43,1030.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.62,1046.33h-48a1.74,1.74,0,0,1-1.73-1.73h0a1.74,1.74,0,0,1,1.73-1.73h48a1.74,1.74,0,0,1,1.73,1.73h0A1.74,1.74,0,0,1,293.62,1046.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 240.67,
    y: 1176.14,
    width: 59.73,
    height: 106.02,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.45,1246.56h-48.2a1.61,1.61,0,0,1-1.6-1.61h0a1.61,1.61,0,0,1,1.6-1.61h48.2a1.61,1.61,0,0,1,1.6,1.61h0A1.61,1.61,0,0,1,293.45,1246.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.45,1262.28h-48.2a1.6,1.6,0,0,1-1.6-1.6h0a1.61,1.61,0,0,1,1.6-1.61h48.2a1.61,1.61,0,0,1,1.6,1.61h0A1.6,1.6,0,0,1,293.45,1262.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.45,1203.18h-48.2a1.6,1.6,0,0,1-1.6-1.6h0a1.61,1.61,0,0,1,1.6-1.61h48.2a1.61,1.61,0,0,1,1.6,1.61h0A1.6,1.6,0,0,1,293.45,1203.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.45,1217.64h-48.2a1.61,1.61,0,0,1-1.6-1.61h0a1.6,1.6,0,0,1,1.6-1.6h48.2a1.6,1.6,0,0,1,1.6,1.6h0A1.61,1.61,0,0,1,293.45,1217.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M294.63,1232.1H246.44a1.62,1.62,0,0,1-1.61-1.61h0a1.61,1.61,0,0,1,1.61-1.6h48.19a1.61,1.61,0,0,1,1.61,1.6h0A1.61,1.61,0,0,1,294.63,1232.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 319.46,
    y: 970.11,
    width: 106.1,
    height: 321.01,
    rx: 5.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 372.06,
    cy: 1136.66,
    rx: 18.72,
    ry: 18.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 372.06,
    cy: 1136.66,
    rx: 14.42,
    ry: 13.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 341.15,
    y: 985.65,
    width: 59.73,
    height: 113.91,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.81,1061.3h-48a1.73,1.73,0,0,1-1.72-1.73h0a1.72,1.72,0,0,1,1.72-1.72h48a1.72,1.72,0,0,1,1.72,1.72h0A1.73,1.73,0,0,1,393.81,1061.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.81,1078.19h-48a1.72,1.72,0,0,1-1.72-1.72h0a1.73,1.73,0,0,1,1.72-1.73h48a1.73,1.73,0,0,1,1.72,1.73h0A1.72,1.72,0,0,1,393.81,1078.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 344.13,
    y: 1011.25,
    width: 51.41,
    height: 3.45,
    rx: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.81,1030.23h-48a1.72,1.72,0,0,1-1.72-1.72h0a1.73,1.73,0,0,1,1.72-1.73h48a1.73,1.73,0,0,1,1.72,1.73h0A1.72,1.72,0,0,1,393.81,1030.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395,1045.77H347a1.74,1.74,0,0,1-1.73-1.73h0a1.74,1.74,0,0,1,1.73-1.73h48a1.73,1.73,0,0,1,1.72,1.73h0A1.73,1.73,0,0,1,395,1045.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 342.05,
    y: 1175.58,
    width: 59.73,
    height: 106.02,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.82,1246h-48.2a1.6,1.6,0,0,1-1.6-1.6h0a1.61,1.61,0,0,1,1.6-1.61h48.2a1.61,1.61,0,0,1,1.6,1.61h0A1.6,1.6,0,0,1,394.82,1246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.82,1261.72h-48.2a1.61,1.61,0,0,1-1.6-1.61h0a1.6,1.6,0,0,1,1.6-1.6h48.2a1.6,1.6,0,0,1,1.6,1.6h0A1.61,1.61,0,0,1,394.82,1261.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.82,1202.62h-48.2a1.6,1.6,0,0,1-1.6-1.6h0a1.61,1.61,0,0,1,1.6-1.61h48.2a1.61,1.61,0,0,1,1.6,1.61h0A1.6,1.6,0,0,1,394.82,1202.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M394.82,1217.08h-48.2a1.61,1.61,0,0,1-1.6-1.61h0a1.6,1.6,0,0,1,1.6-1.6h48.2a1.6,1.6,0,0,1,1.6,1.6h0A1.61,1.61,0,0,1,394.82,1217.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396,1231.54h-48.2a1.61,1.61,0,0,1-1.6-1.61h0a1.61,1.61,0,0,1,1.6-1.61H396a1.61,1.61,0,0,1,1.6,1.61h0A1.61,1.61,0,0,1,396,1231.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1918,775s1.71,9.68,2.55,19.25a6.6,6.6,0,0,1-6.31,7.15c-12.75.53-40,1.56-49.82,1.13a2.15,2.15,0,0,1-1.89-2.94h0A4.73,4.73,0,0,1,1865,797L1910,776.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1919.37,769.27,1918,780.84s-7.89,3.67-13.28-.46l3.27-12.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1918.34,551.71c.6,3,3.19,150.8-12.61,217a2.24,2.24,0,0,0,1.32,2.61,39,39,0,0,0,12.86,2.62,3.86,3.86,0,0,0,3.84-2.78c4.52-15.37,26.16-92.35,29-165.89,3.15-82.17,0-2.8,0-2.8l-1.85-50.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1969.81,780s2.72,4.88,5.35,17.86a4,4,0,0,1-3.54,4.82c-4.21.41-10.69,1-15.89.91a4,4,0,0,1-4-4.48c.58-4.73,2.37-12.5,7.9-18.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1972.2,765.11l-3.21,17.5s-3.17,2.36-9.45.65l1.53-18.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1980.86,556.25c12.92,78-2.8,192.71-8.1,215.16a3.48,3.48,0,0,1-2.83,2.66,23.62,23.62,0,0,1-10.1-.4,3.21,3.21,0,0,1-2.31-3c-.71-18.15.57-129.61-11.47-173.66a10,10,0,0,0-3.86-5.52l-23.36-16.61L1917,548.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1898.54,408.51c38.72-.64,81.44,10.17,81.44,10.17,11.54,67.34,2,145,2,145-30,7.86-63.79-4.81-63.79-4.81-5-28.14-28.22-107.36-28.22-107.36-18.92-2.34-34.5-7.8-47.34-15,9.79-11.34,14.41-25.78,16.41-34.32C1872.75,406.44,1886.6,408.71,1898.54,408.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1784.18,351.48a7.42,7.42,0,0,1,8.62-2.42c5.69,24.07,35.57,43.58,66.26,53.12-2,8.54-6.62,23-16.41,34.32C1791.72,407.86,1784.18,351.48,1784.18,351.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1785.1,352.65c-.4,1.27,4.21,3.19,6.93-2,.09-2.48,1.6-13.1.12-15.13-7.89-10.75-23.2-24.24-23.2-24.24a3.65,3.65,0,0,0-.45,5.06l7.42,7.73c-1.55,2.8-3.44,5.17-4.33,8.57a10.44,10.44,0,0,0,1,7.65c1.31,2.35,3.09,5.4,4.77,7.79A10.25,10.25,0,0,0,1785.1,352.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1779.17,329.11l6.76,5.73,2.13,5.71-6,6.69s-2-11.33-3.54-13.78S1777.77,329.82,1779.17,329.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1965.13,456.17,1980,418.68s36.16,24.57,42.11,55.72a85.67,85.67,0,0,0-31.44,8.43C1988,468.12,1965.13,456.17,1965.13,456.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1933.53,491.44s40.6,22.95,54.3,3.36a15.43,15.43,0,0,0,2.82-12,85.67,85.67,0,0,1,31.44-8.43,43.08,43.08,0,0,1-4.67,29.48c-24,43.9-89.27-2.43-89.27-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1938.4,520.47l-22.16-77.38a2.26,2.26,0,0,0-1.9-1.63c-4-.47-15.65-1.78-29.08-2.92-16.18-1.37-35-2.48-46.2-1.53a2.26,2.26,0,0,0-1.85,3.26c6.38,12.91,32.65,65.46,45.8,82.67a2.25,2.25,0,0,0,1.82.9l51.42-.48A2.26,2.26,0,0,0,1938.4,520.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1883,431.83l-16.07-2.67a1.15,1.15,0,0,0-1.28,1.5l1.59,4.81a1.16,1.16,0,0,0,.94.79l15.46,2.06a1.14,1.14,0,0,0,1.27-1.4l-1-4.21A1.15,1.15,0,0,0,1883,431.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1895,445.43l-1.33-6.89a1.58,1.58,0,0,0-1.4-1.28l-32.45-3.3a1.59,1.59,0,0,0-1.71,2l2.06,8.59a1.61,1.61,0,0,0,1.47,1.22l31.71,1.6A1.61,1.61,0,0,0,1895,445.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1933.05,501.78s3.09-12.7,1.84-17.2-3.66-10.29-11.7-9a117.64,117.64,0,0,0-17.52,4.68s.47,5.86,6.59,4l-3.79,2.93s.54,4.7,5.7,2.19l-3.52,3.89s2.21,3.86,6,1.38S1922.28,503.3,1933.05,501.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1937.76,377.08l12.32,35.63a1.28,1.28,0,0,1-.59,1.54c-3.35,1.86-15.45,7.22-30-2a6,6,0,0,1-2.79-4.32l-4-30.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1909,346.32s-12,23.75-9.91,33.63,18.22,9.87,32,2.49l8.74-25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1929.87,369.53a1,1,0,0,1-.51-1.48,23.51,23.51,0,0,0,3.3-7.48s2.28-1.38-6.11-3.7-20.91-5.91-23.81-13c-2.83-6.93,3.1-23.82,14.33-9.69a1,1,0,0,0,1.6.08c1.65-2.18,6-6.65,12.53-3.55,6.07,2.9,6.93,7.25,6.94,9.43a1.1,1.1,0,0,0,1.23,1.07c3-.44,10.2-.62,13.89,6.86,3,6.17,1.38,9.52-.2,11.13a1,1,0,0,0,.51,1.67c2,.69,4.63,2.46,4.57,7-.08,6.34-7.28,5.47-9.33,5.1a1,1,0,0,0-.89.27c-1.66,1.85-9.2,9.66-17.7,10.28a1.1,1.1,0,0,1-1.12-1.38l3.24-10.48a1.09,1.09,0,0,0-.61-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1928.45,371s9-5.92,9.91-.58-8,7.34-12.59,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1803.64,1339.25a4.49,4.49,0,0,0,4.48-4.49v-536a4.49,4.49,0,1,0-9,0v536A4.49,4.49,0,0,0,1803.64,1339.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1925.17,1339.25a4.48,4.48,0,0,0,4.48-4.49v-536a4.49,4.49,0,1,0-9,0v536A4.49,4.49,0,0,0,1925.17,1339.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2223.75,1342.65a4.58,4.58,0,0,0,1.76-.36,4.48,4.48,0,0,0,2.37-5.88L1998.55,797a4.49,4.49,0,0,0-8.26,3.51l229.34,539.45A4.48,4.48,0,0,0,2223.75,1342.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2082.1,1342.65a4.49,4.49,0,0,0,4.12-6.24L1856.89,797a4.48,4.48,0,0,0-8.25,3.51L2078,1339.92A4.51,4.51,0,0,0,2082.1,1342.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1790.35,
    y: 791.01,
    width: 222.71,
    height: 12.64,
    rx: 2.81,
    transform: "translate(3803.42 1594.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1887.41,885.69h142.08a4.49,4.49,0,0,0,0-9H1887.41a4.49,4.49,0,0,0,0,9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1931.01,
    y: 978.74,
    width: 142.08,
    height: 8.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1973.21,
    y: 1080.76,
    width: 142.08,
    height: 8.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2017.47,1191.76h142.07a4.49,4.49,0,1,0,0-9H2017.47a4.49,4.49,0,1,0,0,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2060.25,1293.78h142.08a4.49,4.49,0,0,0,0-9H2060.25a4.49,4.49,0,0,0,0,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1787.64,1279.22a25.06,25.06,0,0,1-25,25H411.07a25.06,25.06,0,0,1-25-25L374.82,502.5c0-13.73,16.19-40.54,45.84-38.53l1320.91-34.18a63,63,0,0,1,64.63,64.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1763,1255.26a23.71,23.71,0,0,1-23.64,23.65H443.66A23.72,23.72,0,0,1,420,1255.26L409.4,550.15c1.25-42.43,38.45-57.68,61-56.78l1266-34a44.2,44.2,0,0,1,45.38,45.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M477.1,1216.15c1.35-58.28.85-574.35-2.5-618.92s66.07-52.93,172.65-57.94S1653,514.41,1676.16,512.54c52-4.22,62.82,73.56,57.61,242.43-3.91,126.87-10.39,335.86-13.38,432a53,53,0,0,1-52.91,51.4c-216.38.6-1045.71,3-1100.92,4.62C503,1244.85,476.56,1239.26,477.1,1216.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1858.16,1358.67H333a34.22,34.22,0,0,1-34.12-34.13h0A34.22,34.22,0,0,1,333,1290.42H1858.16a34.22,34.22,0,0,1,34.12,34.12h0A34.22,34.22,0,0,1,1858.16,1358.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1043.87,556c-.19-8.8-9.32-15.62-18.72-14l-446.53,36c-14.7,1.19-25.23,12.59-24.09,26.09,10,118.24,74.93,631.86,74.93,631.86.36,7.59,414.71,18.56,414.71,18.56,8.19.09,14.6-5.78,14.44-13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1311.58,1096.65a19.69,19.69,0,0,0,21.08,18.09l340.28-25a19.7,19.7,0,0,0,18.2-21.09L1653.64,559a19.71,19.71,0,0,0-21-18.21l-343.07,24.32a19.71,19.71,0,0,0-18.25,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1331.39,602.82a7.19,7.19,0,0,0-6.63,7.69L1325,613a7.18,7.18,0,0,0,7.68,6.64L1614.16,599a7.18,7.18,0,0,0,6.64-7.69l-.19-2.52a7.17,7.17,0,0,0-7.69-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1346.55,736.9c-3.47.3-6,3.75-5.66,7.7l.22,2.52c.35,4,3.44,6.91,6.92,6.6l247.08-21.64c3.47-.3,6-3.75,5.66-7.7l-.22-2.52c-.35-4-3.44-6.91-6.92-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1348,789.93c-3.47.3-6,3.75-5.66,7.7l.22,2.52c.35,4,3.44,6.91,6.92,6.6l247.08-21.64c3.47-.3,6-3.75,5.66-7.7l-.22-2.52c-.35-3.95-3.44-6.91-6.92-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1353.83,840.52c-3.47.3-6,3.75-5.66,7.7l.23,2.52c.34,4,3.44,6.91,6.91,6.6l247.08-21.64c3.47-.3,6-3.75,5.66-7.7l-.22-2.52c-.35-4-3.44-6.91-6.91-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1361.68,892.67c-3.47.3-6,3.75-5.66,7.7l.22,2.52c.35,4,3.44,6.91,6.91,6.6l247.09-21.64c3.47-.3,6-3.75,5.66-7.7l-.22-2.52c-.35-4-3.45-6.91-6.92-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1358.5,639.89h0a7.18,7.18,0,0,0,7.52,6.25l246.54-13.63a7.19,7.19,0,0,0,6.77-7.7l0-.58a7.17,7.17,0,0,0-7.57-6.64l-246.5,14.21A7.19,7.19,0,0,0,1358.5,639.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1364.3,1076.44l.21,0,277.06-23.73a17,17,0,0,0,15.51-18.55l-34.82-375.67a17,17,0,0,0-18.54-15.39l-276.43,25.76a17.07,17.07,0,0,0-15.39,18.52h0L1346.09,1061A17.07,17.07,0,0,0,1364.3,1076.44Zm-46.75-389.6a11.38,11.38,0,0,1,10.27-12.35l276.42-25.76A11.37,11.37,0,0,1,1616.62,659l1.93,20.83-299.13,22a2.64,2.64,0,0,0-.49.08Zm34.18,373.64-32.29-353h.4l299.23-22,32.37,349.18a11.38,11.38,0,0,1-10.35,12.38L1364,1070.77h-.14A11.4,11.4,0,0,1,1351.73,1060.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1113.22,1145.08a19.7,19.7,0,0,0,21.08,18.1l340.28-25a19.71,19.71,0,0,0,18.2-21.1l-37.5-509.66a19.7,19.7,0,0,0-21-18.2L1091.17,613.5a19.7,19.7,0,0,0-18.25,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1093.79,658.91a20,20,0,0,1,18.57-21.69l304.41-20.52a20,20,0,0,1,21.28,18.57l31.54,457.6a20,20,0,0,1-18.11,21.28l-295.23,27.15a20,20,0,0,1-21.75-18.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1126.09,
    y: 640.88,
    width: 296.65,
    height: 16.89,
    rx: 7.18,
    transform: "translate(-44.22 95.3) rotate(-4.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1160.14,688.32h0a7.19,7.19,0,0,0,7.52,6.26l246.54-13.64a7.18,7.18,0,0,0,6.77-7.69l0-.59a7.18,7.18,0,0,0-7.58-6.64l-246.5,14.22A7.18,7.18,0,0,0,1160.14,688.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1166,1124.87h.2l277.06-23.74a17,17,0,0,0,15.51-18.55L1423.9,706.91a17,17,0,0,0-18.54-15.39l-276.43,25.76a17.06,17.06,0,0,0-15.39,18.51h0l34.19,373.64A17.07,17.07,0,0,0,1166,1124.87Zm-46.76-389.59a11.39,11.39,0,0,1,10.27-12.36l276.43-25.76a11.37,11.37,0,0,1,12.37,10.27l1.93,20.84-299.12,22a2.61,2.61,0,0,0-.5.08Zm34.19,373.64-32.3-353a2.67,2.67,0,0,0,.4,0l299.23-22,32.37,349.19a11.36,11.36,0,0,1-10.35,12.37l-277.06,23.74h-.14A11.39,11.39,0,0,1,1153.38,1108.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M875.28,650.59c49.91,6.84,221.55,28.08,363.6,18.16a11.45,11.45,0,0,1,12.38,10.67l25.62,518.64a13.09,13.09,0,0,1-12.56,13.55c-59.74,3.14-305.76,15.23-393.44,5.86a10.35,10.35,0,0,1-9.37-10.2L861,662.65A12.39,12.39,0,0,1,875.28,650.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M880.56,658.36c48,6.59,213.2,27,349.91,17.48a11,11,0,0,1,11.91,10.27L1267,1185.22a12.58,12.58,0,0,1-12.08,13c-57.49,3-294.25,14.66-378.63,5.64a10,10,0,0,1-9-9.81L866.86,670A11.92,11.92,0,0,1,880.56,658.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1211.08,725.15c2.89,0,5.22-1.59,5.17-3.56s-2.46-3.65-5.34-3.71l-130-2.89c-2.88-.07-4.47,2-3.53,4.69a8,8,0,0,0,7,4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1080.84,734.93c-2.89-.07-4.48,2.05-3.54,4.7a8,8,0,0,0,7,4.84l126.71.62c2.89,0,5.21-1.59,5.16-3.56s-2.45-3.64-5.34-3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1080.74,755.16c-2.89-.06-4.48,2.05-3.54,4.7a7.93,7.93,0,0,0,7,4.84l126.72.62c2.88,0,5.21-1.58,5.16-3.56s-2.45-3.64-5.34-3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1223.47,807.16c2.89,0,5.15-1.59,5-3.56s-2.59-3.62-5.48-3.66l-307.08-3.87c-2.88,0-3.76,1.77-1.94,4l1.2,1.49a12.6,12.6,0,0,0,8.56,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M915.84,816c-2.89,0-3.76,1.78-2,4l1.21,1.49a12.61,12.61,0,0,0,8.55,4.11l299.72,1.47c2.89,0,5.15-1.59,5-3.56s-2.58-3.62-5.47-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M967.93,915.7h-.11l-41.16.71c-5.93.1-10.94-3.74-11.64-8.94L910.46,874a7.27,7.27,0,0,1,1.64-5.62,9.2,9.2,0,0,1,6.27-3.22h0c3.47-.33,8.24-.85,13.49-1.43,11.42-1.25,24.37-2.67,32-3H964c5.46-.15,10.24,3,11.67,7.61,2.37,7.67,2.59,22.29,2.62,37.86C978.32,911.3,973.67,915.54,967.93,915.7ZM918.7,868.37a5.81,5.81,0,0,0-4,2,4.09,4.09,0,0,0-.93,3.15L918.35,907c.48,3.55,4,6.17,8.25,6.1l41.16-.71h.08c3.93-.11,7.12-2.89,7.11-6.23,0-15.32-.24-29.68-2.47-36.93-1-3.21-4.64-5.52-8.49-5.28-7.5.29-21,1.77-31.76,3-5.27.58-10.06,1.11-13.53,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M923.21,871.63c8.63-.81,27.36-3.17,36.27-3.51,3.77-.15,7.15,2,8.12,5.15,1.89,6.14,2,18.49,2,29.88,0,3.42-3.13,6.22-7.06,6.29l-32.89.57c-4,.07-7.48-2.53-7.95-6l-3.65-26.78C917.71,874.45,920,871.92,923.21,871.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1004.94,879.85a3.7,3.7,0,0,0-3.73,5l2.95,9.82a7.28,7.28,0,0,0,6.77,4.88l203.43-5.41a5.11,5.11,0,0,0,5-5.38l-.22-4.45a5.58,5.58,0,0,0-5.52-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M925.11,876.85h0a6.4,6.4,0,0,1,8.77,2.08l8.52,13.94a2,2,0,0,0,3.61-.25l18.91-44.16a2.26,2.26,0,0,1,4.32.83,84.8,84.8,0,0,1-24.06,60.63s-12.2-4.25-22.5-24.77A6.35,6.35,0,0,1,925.11,876.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M970.34,1001.54h-.11l-41.16.71c-5.93.1-10.94-3.74-11.64-8.94l-4.56-33.51a7.27,7.27,0,0,1,1.64-5.62,9.21,9.21,0,0,1,6.27-3.23h0c3.47-.32,8.24-.84,13.49-1.42,11.42-1.25,24.37-2.67,32-3h.17c5.46-.14,10.24,3,11.67,7.62,2.37,7.67,2.59,22.29,2.62,37.86C980.73,997.15,976.08,1001.39,970.34,1001.54ZM921.1,954.22a5.8,5.8,0,0,0-4,2,4.05,4.05,0,0,0-.93,3.15l4.56,33.51c.48,3.55,4,6.17,8.25,6.1l41.16-.71h.08c3.93-.11,7.11-2.89,7.11-6.23,0-15.33-.24-29.68-2.47-36.93-1-3.21-4.64-5.48-8.49-5.28-7.5.29-20.95,1.77-31.76,2.95-5.27.58-10.06,1.1-13.54,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M925.62,957.48c8.63-.81,27.36-3.17,36.27-3.51,3.77-.15,7.15,2,8.12,5.15,1.89,6.14,2,18.49,2,29.88,0,3.41-3.13,6.22-7.06,6.29l-32.89.57c-4.05.07-7.48-2.53-8-6l-3.65-26.78C920.12,960.3,922.42,957.77,925.62,957.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1007.35,965.7a3.7,3.7,0,0,0-3.73,5l3,9.81a7.27,7.27,0,0,0,6.77,4.89L1216.77,980a5.12,5.12,0,0,0,5-5.38l-.22-4.45A5.58,5.58,0,0,0,1216,965Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M927.52,962.7h0a6.41,6.41,0,0,1,8.77,2.07l8.52,14a2,2,0,0,0,3.61-.25l18.91-44.16a2.26,2.26,0,0,1,4.32.83,84.8,84.8,0,0,1-24.06,60.63s-12.2-4.25-22.5-24.77A6.35,6.35,0,0,1,927.52,962.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M968.8,1084.08h-.11l-41.16.7c-5.93.11-10.93-3.74-11.64-8.94l-4.56-33.51a7.26,7.26,0,0,1,1.64-5.61,9.21,9.21,0,0,1,6.28-3.23h0c3.46-.32,8.22-.84,13.46-1.42,10.87-1.19,24.39-2.68,32-3,5.41-.17,10.39,2.91,11.84,7.61,2.36,7.67,2.58,22.28,2.61,37.86C979.19,1079.69,974.54,1083.93,968.8,1084.08Zm-49.23-47.32a5.8,5.8,0,0,0-4,2,4,4,0,0,0-.94,3.14l4.56,33.51c.48,3.56,4,6.18,8.25,6.11l41.16-.71c3.88-.17,7.2-2.87,7.19-6.24,0-15.32-.24-29.67-2.47-36.92-1-3.22-4.63-5.44-8.49-5.28-7.5.29-21,1.76-31.77,2.95-5.26.58-10.05,1.1-13.52,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M924.08,1040c8.63-.8,27.36-3.16,36.27-3.5,3.78-.15,7.15,2,8.12,5.15,1.9,6.14,2,18.48,2,29.88,0,3.41-3.14,6.22-7.07,6.29l-32.89.57c-4,.07-7.47-2.53-7.95-6L919,1045.61C918.58,1042.83,920.88,1040.31,924.08,1040Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1005.82,1048.24a3.71,3.71,0,0,0-3.74,5l3,9.81a7.26,7.26,0,0,0,6.76,4.89l203.43-5.41a5.12,5.12,0,0,0,5-5.38l-.23-4.45a5.59,5.59,0,0,0-5.52-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M926,1045.24h0a6.42,6.42,0,0,1,8.78,2.07l8.51,14a2.06,2.06,0,0,0,3.62-.25l18.9-44.16a2.26,2.26,0,0,1,4.33.83,84.87,84.87,0,0,1-24.07,60.63s-12.19-4.25-22.5-24.77A6.36,6.36,0,0,1,926,1045.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M966.52,1169.22h-.12l-41.15.71c-5.93.1-10.94-3.74-11.65-8.94L909,1127.48a7.24,7.24,0,0,1,1.64-5.61,9.19,9.19,0,0,1,6.28-3.23h0c3.46-.32,8.23-.85,13.48-1.42,11.43-1.26,24.38-2.68,32-3,5.59-.08,10.39,2.91,11.84,7.6,2.36,7.67,2.59,22.29,2.61,37.87C976.9,1164.82,972.26,1169.07,966.52,1169.22Zm-49.24-47.33a5.8,5.8,0,0,0-4,2,4.11,4.11,0,0,0-.94,3.15l4.56,33.51c.49,3.55,4,6.17,8.26,6.1l41.15-.71h.09c3.93-.1,7.11-2.88,7.11-6.23,0-15.32-.24-29.68-2.48-36.93-1-3.21-4.63-5.39-8.49-5.28-7.5.29-21,1.77-31.75,3-5.27.58-10.06,1.11-13.54,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M921.8,1125.15c8.62-.81,27.36-3.16,36.26-3.51,3.78-.14,7.15,2,8.13,5.15,1.89,6.15,2,18.49,2,29.89,0,3.41-3.13,6.22-7.06,6.28l-32.89.57c-4,.07-7.48-2.52-8-6l-3.64-26.78C916.29,1128,918.6,1125.45,921.8,1125.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1003.53,1133.38a3.71,3.71,0,0,0-3.74,5l3,9.82a7.29,7.29,0,0,0,6.76,4.89l203.43-5.41a5.13,5.13,0,0,0,5-5.39l-.23-4.44a5.56,5.56,0,0,0-5.51-5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M923.69,1130.37h0a6.42,6.42,0,0,1,8.78,2.08l8.51,14a2.06,2.06,0,0,0,3.62-.25L963.5,1102a2.26,2.26,0,0,1,4.33.83,84.83,84.83,0,0,1-24.06,60.63s-12.2-4.24-22.51-24.76A6.38,6.38,0,0,1,923.69,1130.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M538.24,1206l4.38-603.4a30,30,0,0,1,30.17-29.73l408.3,3a50.27,50.27,0,0,1,49.9,50.63l-4.07,560a54.22,54.22,0,0,1-54.62,53.83l-403.17-2.92A31.13,31.13,0,0,1,538.24,1206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1011.42,938.45a1.87,1.87,0,0,1-1.87-1.84l-.93-62.73a1.87,1.87,0,0,1,1.84-1.9h0a1.87,1.87,0,0,1,1.87,1.85l.93,62.72a1.87,1.87,0,0,1-1.84,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1010.22,857.36a1.87,1.87,0,0,1-1.87-1.84l-1.82-122.82a1.87,1.87,0,1,1,3.74-.05l1.82,122.81a1.86,1.86,0,0,1-1.84,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1007.74,689.78a1.87,1.87,0,0,1-1.87-1.85l-1.06-71.27c-.14-9.87-9.68-18-21.25-18.09l-65-.57a1.87,1.87,0,0,1,0-3.74h0l65,.57c13.58.12,24.78,9.89,25,21.77l1.05,71.28a1.87,1.87,0,0,1-1.84,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M605.19,758.29a34.53,34.53,0,0,1,35.39-33.63L934,732.14a30.42,30.42,0,0,1,29.63,29.63l10.81,426a22.43,22.43,0,0,1-22.58,23l-336.46-2.47a21.28,21.28,0,0,1-21.12-21.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M664.74,1202.34h0l-37.61-1.45a23.27,23.27,0,0,1-22.29-23.75l1.45-56.81a.86.86,0,0,1,.88-.84h0a.86.86,0,0,1,.84.88l-1.45,56.81a21.55,21.55,0,0,0,20.63,22l37.62,1.44a.87.87,0,0,1,.83.9A.86.86,0,0,1,664.74,1202.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.56,1103.61a.87.87,0,0,1-.84-.88l.24-9.2a.85.85,0,0,1,.88-.84h0a.85.85,0,0,1,.83.88l-.23,9.2a.87.87,0,0,1-.88.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M630,730.94a10,10,0,0,1,11.62-9.7C681.5,727.69,818.86,748,933,742.17a9.26,9.26,0,0,1,9.75,9l11.82,427.88a10.67,10.67,0,0,1-10.3,11c-48,1.62-245.59,7.55-315.79-1.62a8.46,8.46,0,0,1-7.35-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M634.39,741.77a9.65,9.65,0,0,1,11.19-9.34C684,738.64,816.19,758.2,926,752.58a8.92,8.92,0,0,1,9.39,8.65L946.8,1173a10.26,10.26,0,0,1-9.91,10.54c-46.18,1.56-236.35,7.26-303.9-1.56a8.12,8.12,0,0,1-7.07-8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M669.28,774.39l1.85,88.26a5.61,5.61,0,0,0,5.3,5.49c16.32.87,67.16,3.41,95.93,2.65a6.26,6.26,0,0,0,6.08-5.9c1-16.52,3.4-64.61.14-84.83a7.07,7.07,0,0,0-6.56-5.91l-96.42-5.84A6,6,0,0,0,669.28,774.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 724.01,
    cy: 807.32,
    r: 18.96,
    transform: "translate(-357.99 734.95) rotate(-44.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M693.8,862.23l60.38,1.54a4.68,4.68,0,0,0,4.11-7.11c-4.92-8.15-15.35-20.22-33.95-20.16-17.92.06-28.81,10.44-34.34,17.94A4.89,4.89,0,0,0,693.8,862.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M910,788.2c2.2.06,4-1.23,4-2.86s-1.81-3-4-3.13l-104.66-4.53a2.59,2.59,0,0,0-2.76,3.63l.12.38a6.08,6.08,0,0,0,5.23,3.91Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804.87,794.11a2.6,2.6,0,0,0-2.76,3.63l.12.39a6.07,6.07,0,0,0,5.23,3.9l102.09,2.61c2.2.05,4-1.23,4-2.86s-1.81-3-4-3.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M804.45,810.78a2.61,2.61,0,0,0-2.77,3.64l.13.38a6.08,6.08,0,0,0,5.23,3.91l102.09,2.6c2.2.06,4-1.23,4-2.86s-1.81-3-4-3.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M917.36,902c2.19.06,3.94-1.23,3.87-2.86s-1.92-3-4.11-3.09l-246.76-8.24c-2.2-.07-2.91,1.3-1.58,3.06l1.28,1.7a9.38,9.38,0,0,0,6.41,3.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M669.94,904.23c-2.19-.08-2.91,1.3-1.58,3l1.28,1.7a9.43,9.43,0,0,0,6.41,3.3l240.89,6.14c2.2.06,3.94-1.23,3.87-2.86s-1.91-3-4.11-3.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M700.16,968.56h0l-20.92-.73a5.68,5.68,0,0,1-5.67-5l-1.39-17.61a3.83,3.83,0,0,1,1-2.88,4.7,4.7,0,0,1,3.29-1.52h0c1.76-.07,4.25-.22,6.88-.38,5.84-.35,12.45-.74,16.33-.69a5.91,5.91,0,0,1,5.81,4.29c1,4.07.7,11.7.28,19.82A5.21,5.21,0,0,1,700.16,968.56Zm-23.69-26a2.88,2.88,0,0,0-2.07.94,2.13,2.13,0,0,0-.56,1.61l1.39,17.6a4,4,0,0,0,4,3.4l20.92.74h0a3.51,3.51,0,0,0,3.78-3.06c.41-8,.7-15.48-.24-19.32a4.23,4.23,0,0,0-4.1-3h-.06c-3.82,0-10.69.36-16.2.69-2.65.15-5.14.3-6.92.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M721.28,950.84a2.93,2.93,0,0,0-3.08,3.78l.65,2.74a5.42,5.42,0,0,0,4.92,3.95l188.7,2.84a3.92,3.92,0,0,0,4-3.85,4.1,4.1,0,0,0-4-4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M679.49,947.15h0a3.21,3.21,0,0,1,4.4,1.32l3.94,7.5a1,1,0,0,0,1.84,0l10.82-22.53a1.14,1.14,0,0,1,2.17.55,45,45,0,0,1-13.89,31s-6.07-2.55-10.74-13.53A3.36,3.36,0,0,1,679.49,947.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M699,1013.41h0l-20.92-.73a5.68,5.68,0,0,1-5.67-5l-1.4-17.6a3.9,3.9,0,0,1,1-2.89,4.63,4.63,0,0,1,3.28-1.51h0c1.77-.08,4.26-.23,6.89-.38,5.84-.35,12.45-.74,16.33-.69a5.91,5.91,0,0,1,5.81,4.29c1,4.06.7,11.69.28,19.82A5.23,5.23,0,0,1,699,1013.41Zm-23.69-26a2.94,2.94,0,0,0-2.07.94,2.15,2.15,0,0,0-.56,1.62l1.39,17.6a4,4,0,0,0,4,3.4l20.92.73h0a3.5,3.5,0,0,0,3.78-3.05c.41-8,.7-15.48-.23-19.33a4.26,4.26,0,0,0-4.1-3h-.06c-3.82-.05-10.69.36-16.21.69-2.64.16-5.13.31-6.91.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M677.53,989.22c4.4-.19,14-.92,18.51-.86a4.07,4.07,0,0,1,4,2.91c.79,3.25.51,9.69.2,15.64a3.48,3.48,0,0,1-3.76,3.09l-16.71-.59a3.87,3.87,0,0,1-3.88-3.35L674.77,992A2.72,2.72,0,0,1,677.53,989.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M720.14,995.69a2.91,2.91,0,0,0-3.08,3.77l.65,2.75a5.42,5.42,0,0,0,4.92,3.95l188.7,2.83a3.89,3.89,0,0,0,4-3.84,4.08,4.08,0,0,0-4-4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.88,1058.26h-.06l-20.92-.74a5.68,5.68,0,0,1-5.67-5l-1.39-17.6a3.88,3.88,0,0,1,1-2.89,4.66,4.66,0,0,1,3.28-1.52h0c1.76-.07,4.25-.22,6.87-.38,5.56-.33,12.46-.74,16.35-.69a5.89,5.89,0,0,1,5.8,4.29c1,4.07.7,11.7.29,19.82A5.24,5.24,0,0,1,697.88,1058.26Zm-.51-27.08h-.07c-3.82,0-10.69.36-16.21.69-2.64.16-5.13.3-6.91.38h0a3,3,0,0,0-2.07.94,2.21,2.21,0,0,0-.56,1.61l1.4,17.61a4,4,0,0,0,4,3.4l20.92.73h0a3.51,3.51,0,0,0,3.78-3c.41-8,.7-15.49-.24-19.33A4.22,4.22,0,0,0,697.37,1031.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M676.39,1034.06c4.4-.18,14-.91,18.51-.85a4,4,0,0,1,4,2.9c.79,3.26.51,9.7.21,15.65a3.48,3.48,0,0,1-3.76,3.09l-16.72-.59a3.87,3.87,0,0,1-3.87-3.35l-1.11-14.07A2.72,2.72,0,0,1,676.39,1034.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M719,1040.53a2.92,2.92,0,0,0-3.08,3.78l.65,2.74a5.41,5.41,0,0,0,4.92,4l188.7,2.84a3.91,3.91,0,0,0,4-3.84,4.08,4.08,0,0,0-4-4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M696.73,1103.1h-.05l-20.92-.73a5.68,5.68,0,0,1-5.67-5l-1.39-17.61a3.8,3.8,0,0,1,1-2.88,4.66,4.66,0,0,1,3.28-1.52c1.76-.08,4.24-.22,6.87-.38,5.55-.33,12.46-.74,16.34-.69a5.93,5.93,0,0,1,5.81,4.29c1,4.06.7,11.69.28,19.82A5.21,5.21,0,0,1,696.73,1103.1Zm-.5-27.07h-.07c-3.82,0-10.69.36-16.22.69-2.63.15-5.12.3-6.9.38h0a2.91,2.91,0,0,0-2.07.93,2.17,2.17,0,0,0-.56,1.62l1.39,17.6a4,4,0,0,0,4,3.4l20.92.74h0a3.51,3.51,0,0,0,3.78-3.06c.41-8,.69-15.48-.24-19.33A4.22,4.22,0,0,0,696.23,1076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M675.24,1078.91c4.41-.19,14-.91,18.52-.85a4,4,0,0,1,4,2.9c.79,3.26.51,9.7.21,15.64a3.49,3.49,0,0,1-3.76,3.09l-16.72-.58a3.86,3.86,0,0,1-3.87-3.35l-1.11-14.07A2.71,2.71,0,0,1,675.24,1078.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M717.85,1085.38a2.93,2.93,0,0,0-3.08,3.78l.65,2.74a5.42,5.42,0,0,0,4.92,3.95l188.7,2.84a3.92,3.92,0,0,0,4-3.85,4.1,4.1,0,0,0-4-4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M807,670.86c-10.41-7.64-19.63-7.73-26.17-6a13,13,0,0,0-9.54,13.37l2,30.61,33.22,3.8S827.38,685.85,807,670.86ZM791.7,695.13a8.31,8.31,0,1,1,8.51-8.09A8.3,8.3,0,0,1,791.7,695.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M776.93,696.15a.85.85,0,0,1-.83-.8l-.32-4.87a.86.86,0,1,1,1.71-.12l.32,4.88a.85.85,0,0,1-.8.91Zm-.63-9.55a.85.85,0,0,1-.83-.8l-.25-3.7a12.43,12.43,0,0,1,9.13-12.8,25.1,25.1,0,0,1,12.21-.19.86.86,0,0,1-.39,1.68,23.15,23.15,0,0,0-11.37.17,10.69,10.69,0,0,0-7.86,11l.24,3.71a.85.85,0,0,1-.8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M727.34,727.44l.39-15.36a9.37,9.37,0,0,1,9.93-9.11l105.76,6.32a9.12,9.12,0,0,1,8.57,8.79l.51,14.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M762.74,709.45a.86.86,0,1,1,0-1.72l4.56.12h0a.85.85,0,0,1,.83.88.86.86,0,0,1-.88.84l-4.55-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M733.19,722.82a.87.87,0,0,1-.84-.88l.16-6.21a8.79,8.79,0,0,1,9-8.54l16.74.43h0a.86.86,0,1,1,0,1.71l-16.74-.42a7.05,7.05,0,0,0-7.22,6.86l-.16,6.21a.86.86,0,0,1-.88.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M694.32,721l185.1,4.72a13.69,13.69,0,0,1,13.2,11.69l.13.91a11.76,11.76,0,0,1-11.93,13.46L690.91,746.9a7.64,7.64,0,0,1-7.43-8.2l.63-8.49A10,10,0,0,1,694.32,721Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1526,1298c8.89.76,24.33,2,36.49,2.54,7.32.32,11.53-.39,14-1.36,0,.27,0,.53,0,.77a2.51,2.51,0,0,1-2.39,2.36,432.77,432.77,0,0,1-47.79,0,1.79,1.79,0,0,1-1.46-2.68A14.28,14.28,0,0,1,1526,1298Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1562.45,1300.52c-12.16-.54-27.6-1.78-36.49-2.54,8.74-10.66,36.49-17.84,36.49-17.84h7.84a32.5,32.5,0,0,1,6.11,19C1574,1300.13,1569.77,1300.84,1562.45,1300.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1571.61,1267.42l-.73,14.43a3.3,3.3,0,0,1-2.83,3.09,12.94,12.94,0,0,1-5.89-.48,3.92,3.92,0,0,1-2.64-3l-2.53-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1673.42,1296.94c3.86-.5,5.6-2.34,6.33-4.31l0,0c.56,2.08-.75,4.23-3.38,5.26a23.8,23.8,0,0,1-9.35,1.34,9.64,9.64,0,0,1-7-3l0,0C1662.91,1297.61,1667,1297.76,1673.42,1296.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1655.24,1266.33h6.46c9.85-.18,16,18.91,18,26.3-.73,2-2.47,3.81-6.33,4.31-6.43.82-10.51.67-13.42-.66-5.32-6.43-8-15.86-9.22-21.36C1649.34,1268.67,1655.24,1266.33,1655.24,1266.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1660.87,1254l3.59,13.12a3.48,3.48,0,0,1-2,4,14.77,14.77,0,0,1-7.43,1.65,3.18,3.18,0,0,1-2.64-2L1647.1,1257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1665.15,1258.05c-4.47,3.93-19,4.45-19,4.45-52.32-124.77-73.73-142.5-73.73-142.5,7.56,47.1,1.22,151.36,1.22,151.36-8.63,3.79-19.76,0-19.76,0A799.25,799.25,0,0,0,1527.17,1074c35.36-.79,54.17-12.82,60.31-17.64C1617,1103.59,1665.15,1258.05,1665.15,1258.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1578.5,912.88c6.69,33.17,4.29,92.54,2.71,119.63-.44,7.61,4.91,18.16,9.23,25.36a2.25,2.25,0,0,1-.92,3.18c-7.23,3.69-31.75,15.15-60.17,16.57a4,4,0,0,1-4.07-3c-21.08-78.2-45.56-128.17-45.56-128.17C1506.75,903.56,1578.5,912.88,1578.5,912.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1620.48,1008.08c-2.15,15.46-8.5,32.32-21.21,50.22l-4.83-3.91a147.27,147.27,0,0,0,2.41-48C1604.69,1004.88,1613.94,1006.44,1620.48,1008.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1571,953.81l7.48-40.93s50,37.93,42,95.2c-6.54-1.64-15.79-3.2-23.63-1.69C1594.56,988,1587.74,968.06,1571,953.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1479.72,946.44,1499,987.7c-3.12,24.91-16.59,35.68-31.11,39.82a86.87,86.87,0,0,0-6.48-26.87C1480,981.61,1479.72,946.44,1479.72,946.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1461.41,1000.65a86.87,86.87,0,0,1,6.48,26.87c-38.74,14.93-49-14-49-14l7.16-1.26C1442.23,1013.92,1453.52,1008.74,1461.41,1000.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1497.48,895.51l9.31,34a6.66,6.66,0,0,0,8.9,4.4,136.53,136.53,0,0,0,13.42-6.09,8.88,8.88,0,0,0,3.16-12.81l-19.35-28.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1401.14,991.41l238.53,86.81a18.26,18.26,0,0,1,10.37,24.72l-.72,1.6a17,17,0,0,1-22.58,8.38l-231.61-107.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1291.5,
    cy: 939.19,
    rx: 117.75,
    ry: 115.62
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1160.48,939.19c0,71,58.66,128.65,131,128.65s131-57.6,131-128.65-58.66-128.66-131-128.66S1160.48,868.13,1160.48,939.19Zm19.25,0c0-60.62,50-109.76,111.77-109.76s111.78,49.14,111.78,109.76-50,109.75-111.78,109.75S1179.73,999.8,1179.73,939.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1412.56,955h-.09a.74.74,0,0,1-.64-.82c.39-3,.66-6.06.81-9.1a.73.73,0,0,1,.77-.7.74.74,0,0,1,.7.77c-.16,3.08-.43,6.18-.82,9.22A.73.73,0,0,1,1412.56,955Zm-.9-36a.73.73,0,0,1-.72-.6,116.75,116.75,0,0,0-7-23.86h0c-18.64-45.21-62.79-74.42-112.47-74.42a122.59,122.59,0,0,0-65.13,18.61.73.73,0,0,1-1-.23.74.74,0,0,1,.23-1,124,124,0,0,1,65.91-18.83c50.28,0,95,29.57,113.83,75.34h0a118.24,118.24,0,0,1,7.06,24.16.74.74,0,0,1-.6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1477.11,869.57c-.08.58,7.77,39,7.77,39l21.87-5-2-37.56S1478.53,859.73,1477.11,869.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1499.8,874.48l2.62,19.69a2.69,2.69,0,0,1,0,.75c-.22,1.54-1.36,6.8-6.67,5.3-4.81-1.37-9.22-2.54-12.27-1.61a2.77,2.77,0,0,0-1.91,3.21,121.08,121.08,0,0,0,5,17.92,2.77,2.77,0,0,0,3.36,1.64c4.15-1.21,12.83-4,19.28-7.89a2.8,2.8,0,0,0,1.35-2.5c-.21-5-.79-20.08-.3-24.31.46-4,5.34-6.36,7.46-7.21a2.72,2.72,0,0,0,1.51-1.52c1-2.46,2.34-8.16-4.83-10.49a2.77,2.77,0,0,1-1.76-3.59c1.06-3,1.51-7.47-4-10s-9.86.48-12.13,2.92a2.78,2.78,0,0,1-3.54.42,2.19,2.19,0,0,0-2.49.09,2.73,2.73,0,0,1-3.87-1.18c-1.35-2.77-4.11-5.74-9.63-4.79-9.8,1.67-10.91,12.53-8.32,18.89s13.1,3.94,18.38.74c4-2.44,9.22.11,11.48,1.48A2.74,2.74,0,0,1,1499.8,874.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1511.16,893.86s-4-11.28.11-14,10.27-1.33,8.92,6.84C1518.51,896.82,1511.16,893.86,1511.16,893.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1596.43,1054.79l-22.55-1.84-9.76,9s2.31,3.19,9.53,1.36a103.11,103.11,0,0,1,17.12-2.29s10,4.5,10.09-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1421.77,1019.64c-2,1.52-8.63-1.66-12.72-3.86a4.69,4.69,0,0,1-2.27-5.55c1-3.11,2.62-7.11,4.64-7.62C1414.77,1001.78,1429.81,1013.36,1421.77,1019.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1635,1109.43a.74.74,0,0,1-.7-.49.75.75,0,0,1,.46-.94c6.79-2.34,10.35-6.15,10.57-11.32a12.56,12.56,0,0,0-8.22-12.09l-28.64-11.17a.73.73,0,1,1,.53-1.37l28.64,11.17a14,14,0,0,1,9.16,13.53c-.25,5.82-4.14,10.08-11.56,12.64A.67.67,0,0,1,1635,1109.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1599.87,1070a.86.86,0,0,1-.27,0l-3.71-1.45a.74.74,0,1,1,.54-1.37l3.71,1.45a.74.74,0,0,1,.42,1A.76.76,0,0,1,1599.87,1070Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.45,1040.07s2.07,3.61-10.93,9.49c-7.24,3.27-21.37,8.17-23,21.88-.84,7.07-6.52,12.82-14.29,14-19.33,3-49,12.5-53.28,43-3.24,23.28,10,31.9,23.81,34.74,10.14,2.1,17,10.87,15.13,20.12-1.8,8.86,1.3,19,18.38,26.87,38.27,17.55,75.08-44,75.08-44l5.87-106.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.46,1149.48a2.66,2.66,0,0,1-1.41-.54c-7.21-5.09-11.17-15.79-9.63-26,.93-6.13,3.55-11.45,7.39-15a32.32,32.32,0,0,1,9.09-5.44,162.44,162.44,0,0,1,16-6.15l1.34-.43a45.3,45.3,0,0,0,9.39-3.77,16.82,16.82,0,0,0,7.71-8.93,29.31,29.31,0,0,0,1.1-7c.22-2.88.45-5.85,1.69-8.41a.09.09,0,0,1,.14,0,.13.13,0,0,1,0,.17c-1.22,2.51-1.44,5.45-1.66,8.3a29.15,29.15,0,0,1-1.12,7,17.09,17.09,0,0,1-7.8,9.06,46.5,46.5,0,0,1-9.43,3.79l-1.34.42a164.12,164.12,0,0,0-16,6.14,32.64,32.64,0,0,0-9,5.41c-3.8,3.49-6.4,8.76-7.31,14.83-1.53,10.13,2.39,20.72,9.53,25.76.54.38,1.57.84,2,.14a.09.09,0,0,1,.14,0,.17.17,0,0,1,0,.18A1,1,0,0,1,264.46,1149.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.79,1139.89a.1.1,0,0,1-.1-.05c-3.5-4.57-5.37-9.39-5.4-13.95a15.32,15.32,0,0,1,6.91-13.05.15.15,0,0,1,.18,0,.14.14,0,0,1,0,.18,15.05,15.05,0,0,0-6.8,12.83c0,4.5,1.88,9.27,5.35,13.8a.13.13,0,0,1,0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M484.44,1009.7s-47,69.64-104.07,83.79c0,0,11.69,28.6,20.37,31.76,0,0,69.57-54.23,86.78-105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.68,1454l-1.36,11.64a5,5,0,0,1-4.58,4.26,89.87,89.87,0,0,1-17.18.49,4.16,4.16,0,0,1-3.91-5.27c1.49-4.5,4.26-11.28,8.34-15.3l14.25-.2A4.15,4.15,0,0,1,261.68,1454Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M370.85,1316.32l2.63,12.76c-7.82-8.41-17.77,62-7.64,103.39,1.1,4.5,1.26,9.18,4,13.08l14.37,20.36-35.92-18.47-.78-3.92,5.7-7.33-9.11-82.5a23.36,23.36,0,0,1,2.94-14.07l7.14-12.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M386.62,1468.85l-11.36.17a7.18,7.18,0,0,1-5.47-2.33c-3.61-4.11-11.09-12.12-14.6-12.28-4.73-.21-3.86,14.95-3.86,14.95l-2.64,0L345,1450.59a10.86,10.86,0,0,1,6.27-11.76h0s1.21,7.2,7.12,10.31,24.08,14.28,24.08,14.28a17.74,17.74,0,0,1,4.61,0C390.68,1464,390.26,1468.8,386.62,1468.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M322.21,1323.11s-45.73,81.6-52.91,100.18-9.52,34-9.59,35.49c-.12,2.29-3.22,4.52-11.87,4.64-4.46.07-6.67-1.52-7.77-3.07a4.18,4.18,0,0,1-.27-4.41c2.64-5,11-21.11,14.09-28.4,3.68-8.7,11.22-48,15.5-61.66s9.11-28.53,28.55-42.42C297.94,1323.46,311.23,1311.31,322.21,1323.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.08,1213.57c4.72-13.56,26.57-23.47,26.57-23.47,11.34-46.8-20-72.73-20-72.73,19.16-17.16,54.46-25.36,54.46-25.36s34.22,21.86,30.52,39.42C412.5,1141.72,392,1193.2,392,1193.2L390,1318.66c-.07,4-3.4,7.35-7.81,7.88-32.08,3.78-85.77-1.93-85.77-1.93C315.21,1293.34,318.37,1227.13,323.08,1213.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M361.49,1061.52l-9.17,40.33c-.89,3.55,2.67,2.92,6.62,2.19,6.46-1.2,14.77-3.6,17.48-8.2a3.92,3.92,0,0,0,.48-1.52l3.76-27.93a5,5,0,0,0-3.34-5.21l-8.26-3.17C365.88,1056.79,362.25,1058.47,361.49,1061.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M484.36,1023.89c.17,1.42-5.66,2.49-7.63-3.54.47-2.64,1.17-14.18,3.37-16,11.72-9.71,32.73-20.75,32.73-20.75a3.69,3.69,0,0,1-.65,5.44l-10.46,6.61c1.16,3.29,2.82,6.19,3.07,10a10.56,10.56,0,0,1-3,7.87c-2.06,2.2-4.85,5-7.37,7.22A13.11,13.11,0,0,1,484.36,1023.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M489.67,1019l-.92-.4c.21-.47,5.07-11.65,7.44-14a3.52,3.52,0,0,0,1.39-2.45,2,2,0,0,0-.87-1.35l-8.84,4.44-3.74,5.48-.82-.56,3.88-5.69,9.61-4.84.25.18a3.12,3.12,0,0,1,1.52,2.26c.08,1-.47,2.07-1.68,3.25C494.66,1007.55,489.72,1018.91,489.67,1019Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M376.25,1028.17s10.61,6.27,15.4,22.56-2.42,22.25-9.93,22-18.45-2.19-28.09-13.78S362.36,1020.53,376.25,1028.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M363,1052.21s-4.26-23.37,17.32-20.1l4.42,4s10.34-10.87-1.46-18.81-27.93-5.62-36.62,9.26S335,1051.9,342.61,1061s13.16,1.11,13.16,1.11-3.58-7.89-.79-11.33,6.58,1.88,6.58,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M362,1057.45s-2.12-12-8.86-8.48,2.65,11.22,6.41,13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.78,1149.07a3.12,3.12,0,0,1,3.52,3.38l-13.09,82.92a3.17,3.17,0,0,1-3.07,2.54l-145.6,7.63a3.18,3.18,0,0,1-3.47-2.79l-5-78.51a3.08,3.08,0,0,1,3-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M418,1143.56a3.32,3.32,0,0,1,3.8,3.13l-1.36,89.74a3.28,3.28,0,0,1-3.25,3.06l-145.16,7.6a3.35,3.35,0,0,1-3.61-2.71l-11.55-82.26a3.19,3.19,0,0,1,3-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M403.44,1139.2a4.2,4.2,0,0,1,5,3.35l11.47,92.74a4,4,0,0,1-4,4.27L273,1247a4.13,4.13,0,0,1-4.49-3.5l-7.34-76.35a3.94,3.94,0,0,1,3.45-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M349.75,1138.79,329.86,1117s-34.19,30.31-43.48,65.78l17.57,9.63C314.59,1171.62,325.67,1155.3,349.75,1138.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M311.58,1244.75a4.32,4.32,0,0,1-3.82-2.18c-1.84-3.47-5.45-10.08-7.32-12.2a9.81,9.81,0,0,1,5.58-.22c3.57.7,6.57-.66,6.64-2.45l-16.78-6.22c-.63-1.53-3.21-10.13,8.07-29l-17.57-9.63a68.35,68.35,0,0,0,2.16,43s3.59,17.21,10.29,20.61,16.71-1.66,16.71-1.66Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImg2);
export default __webpack_public_path__ + "static/media/home_img_2.fff745912bdaa4e3d86e64d96c3de8bb.svg";
export { ForwardRef as ReactComponent };